import { Component, createRef, ReactNode } from "react";
import HoveredOutline from "./HoveredOutline";
import SelectedOutline from "./SelectedOutline";
import DraggedComponent from "./DraggedComponent";
import { SiteData } from "./Data/SiteData";
import { EditorState, PannelMenuType as PanelMenuState, PannelMenuType, ResizeType } from "./EditorTypes";
import StyleBuilder, { StyleBuilderState } from "./Stylebuilder";
import LeftPanel from "./LeftPanel";

import { elementResizeLockedKey } from "./Data/ConstantKeyWords";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import React from "react";
import { createAllWBComponents, GetWBComponentByTypename } from "./Data/WBData";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, getNodeStyleAttributes, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WBCanvas, { assignParentsToLayoutRecursive, CreateBlankLayoutNode } from "./WBCanvas";
import PagesMenu from "./Menus/PagesMenu";
import Loader from "../Common/Loader";
import SizePreviewMenu from "./Menus/SizePreviewMenu";
import  { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import WBComponentTemplateMenu from "./Menus/WBComponentTemplateMenu";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import SaveAndPublishMenu from "./Menus/SaveAndPublishMenu";
import ComponentDesignPanel from "./Menus/ComponentDesignPanel";
import PageSelectMenu, { GetLinearPageData } from "./Menus/PageSelectMenu";
import PreviewScreen from "./PreviewScreen";
import { CSSClassNames } from "./CSSClassNameConstants";
import { LoadPageContentAsync, SaveSiteStyle, SavePageAsync, PublishPage, SaveHeaderAsync, SaveFooterAsync, adminLogoData, GetStyleListForLayoutId, ActivateDefaultStyle } from "./Utilities/PageDataHandler";
import { AlertConfirm, GenericConfirmation } from "./ConfirmationPopups";
import PanelCollapser from "./PanelCollapser";
import { GeneratePublishForSingleNode, GeneratePublishHTMLString, GetFontIncludes, GetStylingForSingleNode, PurifyWithAtts } from "./GeneratePublishHTMLString";
import GeneralSettings from "components/Generalsettings/GeneralSettings";
import DomainMenus from "./Menus/DomainMenus";
import EditorSettings from "./Menus/EditorSettings";
import { EditorColorThemes } from "./EditorColorThemes";
import { LeftCaret } from "./Icons/Carets";
import Toast, { CustomColorToast, ToastWithCTA, ToastWithPreview } from "./Toast";
import HoverToolTip from "./HoverToolTip";
import "../../Layout/Header/Header.scss"
import { blogPlaceHolderText, editTextPlaceHolder } from "./Data/WBComponentDefaults";
import ReactDOM from "react-dom";
import ComponentContextMenu from "./Menus/ComponentContextMenu";
import { ValidateToken } from "vagaro-website-rendering/src/components/Utilities/BusinessData";
import { LoginUserType, MobileCallbackTypes, utils } from "utils/Utils";
import ProcessNodes from "./Utilities/ProcessNodes";
import SetNodeDomBoundsAsync  from "./Utilities/GetNodeDomBounds";
import SettingsMenuRedo from "./Menus/SettingsMenuRedo";
import AnnouncementBanner from "./WBComponents/AnnoucementBanner";
import ReactDOMServer from "react-dom/server";
import VersionHistoryMenu from "./Menus/VersionHistoryMenu";
import generateGlobalStyleFromSiteData, { GetBlogStyling } from "vagaro-website-rendering/src/components/Utilities/GenerateGlobalStyleFromSiteData";
import store from "app/store";
import SectionTemplateMenu, { ShowSectionTemplatesToBusinessUsers } from "./Menus/SectionTemplateMenu";
import RenderCookieBanner from "vagaro-website-rendering/src/components/ComponentRenders/RenderCookieBanner";
import DOMPurify from "dompurify";
import { CreateSiteStylingFromString, setStyleDenotation } from "components/SetLibrary/SetUtils";
import { SiteStyling } from "vagaro-website-rendering/src/components/Definitions/SiteStyling";
import CreateNewGUID from "vagaro-website-rendering/src/components/Utilities/CreateNewGUID";
import Multilocation from "components/Multilocation/Multilocation";
import RenderPopup from "vagaro-website-rendering/src/components/ComponentRenders/RenderPopup";
import { GetNodeComponenentAttributeBinding } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { SetGlobalCurrentPageData, SetGlobalCurrentPageId } from "vagaro-website-rendering/src/components/Utilities/WindowUtils";
import { ClosestWithClass, ClosestWithTag } from "vagaro-website-rendering/src/components/Utilities/HTMLHelpers";
import GearIcon from "./Icons/LightGearIcon";
import { WarningToast } from "vagaro-website-rendering/src/components/Utilities/Toast";
import { GetReadTime, InlineTextEditorWrapper, TextEditorImagePopUp } from "./InlineTextEditorFull";
import { BlogPostInfo, BlogPostStatus, CreateGenericPost, EditPostSettings, GetBlogTagsOrCategories, GetPostInfoFromResponse, LoadBlogEditorDetails, LoadBlogStyling, PublishBlogPost, PublishBlogStyle, SaveBlogPostContent, SaveBlogStyling } from "vagaro-website-rendering/src/components/Utilities/BlogAPI";
import  { ApplyBlogInfoFromBlogHeading as ApplyBlogInfoFromHeading, BlogAndStylingSyncKeys } from "./WBComponents/BlogHeading";
import { GetIdListFromChips } from "./Menus/BlogSettingsPopup";
import { FindMissingLinks } from "./Utilities/LinkChecker";







export const enum EditorMode  {
  Normal,
  Blogging
}

const staticWhenBloggingComponents = [wBComponentTypeNames.column,wBComponentTypeNames.section];
const nonDropWhenBloggingComponents = [wBComponentTypeNames.pageRoot,wBComponentTypeNames.section];

function ToggleComponentStaticForBlogging(on:boolean){

  staticWhenBloggingComponents.forEach((item)=>{

    let comp = GetWBComponentByTypename(item);
    comp.isStatic = on;

  });
}

type WebDesignerState = {

    editSate: EditorState;
    isLoading:boolean,
    selectedTargets:{dom:HTMLElement,layout:LayoutNode}[];
    layout: LayoutNode;
    layoutMode:boolean;
    screenSize:ScreenSize;
    draggedLayoutNode: LayoutNode | null;
    draggedLayoutClone: LayoutNode | null;
    styleMenuState:StyleBuilderState;
    panelMenuState:PanelMenuState;
    currentPageId:string;
    mode:EditorMode;
    postInfo:BlogPostInfo;

    // saveState:SaveState;
    // dirtySave:boolean;
    // published:boolean;

    rightPannelExpanded:boolean;
    leftPannelExpaned:boolean
    siteData:SiteData;
    pageMenuLoadToggle:boolean;
    pageSelectKey:number;
    canvasScale:number;
    dispatch:any;

}


export function OpenGlobalImagePicker(onSelect:(url:string)=>void){

  let anyWindow = window as any;
  if(anyWindow.openImagePicker ){
    anyWindow.openImagePicker(onSelect);
  }

}


type WebDesignerProps = {

    layout: LayoutNode|null;
    siteData:SiteData;
    startLoading?:boolean;
    styleId?:string;
    layoutId?:string;
    reactBusinessId:number;
    businessName?:string;
    businessGroup?:string;
    countryId?:string;
    initialPageId?:string;
    isPromoBusiness?:boolean;
    dispatch:any;
}

export enum SaveType{
    All,
    Style,
    Layout
}

export enum SaveState{
    Unsaved,
    InProgress,
    Success,
    Error
}

function distanceBetweenPoints(x1: number, y1: number, x2: number, y2: number): number {
    const deltaX = x2 - x1;
    const deltaY = y2 - y1;
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
}

function sanitize(input: string) {
  // Replace potentially dangerous characters with their HTML entity equivalents
      return DOMPurify.sanitize(input);
}



//const defaultNavBar = `{"id":"m6cd18a7ae4237428177fb07eb6091fc","typename":"navigationBar","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"Your Text Here","children":[{"id":"ta0173ed4f2f013890ac7ef53b143344","typename":"Column","screenSizeStyleAttributes":[{"alignItems":"center","alignContent":"center"},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"Cc6bd510da0a591980ad4ed490960abf","typename":"container","screenSizeStyleAttributes":[{"justifyContent":"center","alignContent":"center","alignItems":"center","flexDirection":"row","width":"100%","height":"88px","gap":"24px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center","anchorType":"top-left"},"content":"","children":[{"id":"Hd283cdc1b78731986a8e60f7eba5f24","typename":"navigationList","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"pages":"[{\"name\":\"New Page 1\",\"url\":\"new-page-1\",\"pageId\":\"8f1d229e-ee1d-45dd-bdf5-701ca69d711f\",\"titleTag\":\"\",\"isDisabled\":false,\"content\":\"\",\"metaDescription\":\"\",\"order\":1,\"folderId\":\"\",\"isFolder\":false,\"openGraphImageUrl\":\"\",\"children\":[],\"isLandingPage\":true},{\"name\":\"New Page 2\",\"url\":\"new-page-2\",\"pageId\":\"c4678800-4436-49cb-a855-cf264c41694f\",\"titleTag\":\"\",\"isDisabled\":false,\"content\":\"\",\"metaDescription\":\"\",\"order\":2,\"folderId\":\"\",\"isFolder\":false,\"openGraphImageUrl\":\"\",\"children\":[],\"isLandingPage\":false},{\"name\":\"New Page 3\",\"url\":\"new-page-3\",\"pageId\":\"7063dd07-1454-40c8-901e-801347c790d6\",\"titleTag\":\"\",\"isDisabled\":false,\"content\":\"\",\"metaDescription\":\"\",\"order\":3,\"folderId\":\"\",\"isFolder\":false,\"openGraphImageUrl\":\"\",\"children\":[],\"isLandingPage\":false},{\"name\":\"New Page 4\",\"url\":\"new-page-4\",\"pageId\":\"78c24186-8b23-43e6-98c3-235c644230fe\",\"titleTag\":\"\",\"isDisabled\":false,\"content\":\"\",\"metaDescription\":\"\",\"order\":4,\"folderId\":\"\",\"isFolder\":false,\"openGraphImageUrl\":\"\",\"children\":[],\"isLandingPage\":false}]","anchorType":"top-left"},"content":"Your Text Here","children":[]}]}]}]}`

const ignoreJSONSerialKeys = [
    "parent",
    "childIndex",
    "inView",
    "tokenClasses",
    "data",
    "forceUpdate",
    "screenResolutions",
]
export function stringifyLayout(obj:LayoutNode){


    return JSON.stringify(obj,(k,v)=>{

        if(ignoreJSONSerialKeys.includes(k))
            return;
        else
            return v;

    });

}


declare global {
  interface Window { ClicktoDomains: any; }
}
export default class WebDesigner extends Component<WebDesignerProps, WebDesignerState> {
  mouseX: number = -1;
  mouseY: number = -1;

  config = {
    autoRemoveEmptySections: true,
    ignoreFirstCreationWhenNested: false,
    autoScrollAtEdges: true,
  };

  previousSelection: LayoutNode | null = null;

  undoStates: string[] = [];
  redoStates: string[] = [];

  canvasRef: React.RefObject<HTMLDivElement> = createRef();
  DomainButtonRef: React.RefObject<HTMLButtonElement> = createRef();
  copiedAttributeCollection: AttributeCollection | null = null;
  resizeParentList:string[] = [];
  resizeTarget: { dom: HTMLElement; layout: LayoutNode } | null = null; //targeted elem we are resizing. since multiple elem can be selected, we need to track which one we are resizing
  currentResizeType: ResizeType = ResizeType.TopRight; //current resize direction used in resizeState
  lastEventWasTouch: boolean = false;
  mouseIsDown: boolean = false; //use to track mouse distance to init drag
  mouseDownPoint: { x: number; y: number } = { x: -1, y: -1 }; //use to track mouse distance to init drag
  draggedDropList: string[] = []; // cached drop list belonging to the dragged component, used to validate drop points
  layoutNodeDictionary: { [key: string]: LayoutNode } = {};
  activeDropPoint: HTMLElement | null = null;
  styleBuilder: StyleBuilder | null = null;
  draggedRenderComponent: DraggedComponent | null = null;

  autoScrollIntervalId: any = -1;
  autoScrollDir = 0;
  prevHeaderSave: string = "";
  prevFooterSave: string = "";
  saveType: SaveType = SaveType.All;
  templateNode: LayoutNode | null = null;
  hoveredDom: HTMLElement | null = null;
  componentDirty: boolean = false;
  shiftKeyIsDown: boolean = false;
  availableDropTargets: NodeListOf<Element> =
    document.querySelectorAll(".drop-target");
  updateHoverComponent: (dom: HTMLElement | null) => void = () => {};
  saveIntervalId: any = null;
  updateSaveState: (state: SaveState) => void = () => {};

  saveState: SaveState = SaveState.Success;
  dirtySave: boolean = false;
  published: boolean = false;
  firstTimeLoad = true;
  firstTimeCompile = true;
  panelMenuLocked:boolean = false;
  panelLockMessage = "You have unsaved changes. Are you sure you want to leave?";

  promptForPanelExit( onSuccess:()=>void){
    GenericConfirmation(this.panelLockMessage,()=>{;this.panelMenuLocked = false; onSuccess()},()=>{});
  }


  onDeselectMenu = () => {};
  openToAnnouncementBar = () => {};
  openToDomainSettings = () => {};
  openToBlogSettings = () => {};
  openToMultiLocationSettings = () => {};
  openSettingsMenu = () => {};

  constructor(props: WebDesignerProps) {
    super(props);
    let newLayout = props.layout ?? this.createDefaultLayout();
    const isFromStyle = window.location.href.includes("menu=sitestyling"); //

    if(this.resizeParentList.length == 0){
      let list = createAllWBComponents();
      for(let i = 0;i<list.length;i++){
        if(list[i].isSubComponent){
          this.resizeParentList.push(list[i].typename);

        }
      }
    }


    this.state = {
      mode:EditorMode.Blogging,
      pageMenuLoadToggle: false,
      editSate: EditorState.Normal,
      isLoading: props.startLoading ?? false,
      screenSize: ScreenSize.Desktop,
      layout: newLayout,
      currentPageId: props.initialPageId ?? "",
      draggedLayoutNode: null,
      draggedLayoutClone: null,
      styleMenuState: isFromStyle
        ? StyleBuilderState.Fonts
        : StyleBuilderState.SelectedComponent,
      panelMenuState: PanelMenuState.None,
      selectedTargets: [],
      layoutMode: false,
      postInfo: CreateGenericPost(),
      // saveState:SaveState.Success,
      // dirtySave:false,
      // published:false,
      leftPannelExpaned:true,
      rightPannelExpanded: isFromStyle,
      siteData: props.siteData,
      pageSelectKey: 0,
      canvasScale: 1,
      dispatch:props.dispatch
    };

    if(this.state.mode == EditorMode.Blogging){
      ToggleComponentStaticForBlogging(this.state.mode == EditorMode.Blogging);
    }

    props.siteData.designer = this;

    this.setActiveDropPoint = this.setActiveDropPoint.bind(this);
    this.promptForPanelExit = this.promptForPanelExit.bind(this);
    this.getPreviewLink = this.getPreviewLink.bind(this);
    this.clearActiveDropPoint = this.clearActiveDropPoint.bind(this);
    this.GetMoveInfoFromActiveDropPoint =
      this.GetMoveInfoFromActiveDropPoint.bind(this);
    this.moveComponentByObj = this.moveComponentByObj.bind(this);
    this.moveComponentAdjacent = this.moveComponentAdjacent.bind(this);
    this.fillLayoutNodeDictionaryRecursive =
      this.fillLayoutNodeDictionaryRecursive.bind(this);
    this.selectParentOfCurrentSelected =
      this.selectParentOfCurrentSelected.bind(this);
    this.selectElementByLayoutObj = this.selectElementByLayoutObj.bind(this);
    this.activateClosestDropPoint = this.activateClosestDropPoint.bind(this);
    //Input Event Handlers

    this.handleKeyPressEvent = this.handleKeyPressEvent.bind(this);
    this.handleMouseMovement = this.handleMouseMovement.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.handlePreventBrowserDrag = this.handlePreventBrowserDrag.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.emulateClickFromTouch = this.emulateClickFromTouch.bind(this);
    this.emulateMouseMoveFromTouch = this.emulateMouseMoveFromTouch.bind(this);
    this.handleContextClick = this.handleContextClick.bind(this);
    this.handleTouchUp = this.handleTouchUp.bind(this);
    this.toggleLoading = this.toggleLoading.bind(this);

    this.onCanvasClick = this.onCanvasClick.bind(this);
    this.flagDirtySave = this.flagDirtySave.bind(this);
    // this.checkDirty = this.checkDirty.bind(this);

    //userfunctions functions
    this.hoverElement = this.hoverElement.bind(this);
    this.hoverById = this.hoverById.bind(this);
    this.startDragFromId = this.startDragFromId.bind(this);
    this.startDrag = this.startDrag.bind(this);
    this.endDrag = this.endDrag.bind(this);
    this.startResize = this.startResize.bind(this);
    this.startAbsoluteMove = this.startAbsoluteMove.bind(this);
    this.moveElementAbsolutely = this.moveElementAbsolutely.bind(this);
    this.tryEditContentOfHoveredElement =
      this.tryEditContentOfHoveredElement.bind(this);

    this.copyComponentAttributes = this.copyComponentAttributes.bind(this);
    this.pasteComponentAttributes = this.pasteComponentAttributes.bind(this);
    this.clearComponentAttributes = this.clearComponentAttributes.bind(this);
    this.pasteOjbectInPlace = this.pasteOjbectInPlace.bind(this);

    this.deleteSelectedDoms = this.deleteSelectedDoms.bind(this);
    this.deleteObjectById = this.deleteObjectById.bind(this);
    this.deselectAll = this.deselectAll.bind(this);
    this.setPreviewState = this.setPreviewState.bind(this);
    this.updateStyleAttributeByValue =
      this.updateStyleAttributeByValue.bind(this);
    this.selectElement = this.selectElement.bind(this);
    this.toggleLayoutMode = this.toggleLayoutMode.bind(this);
    this.openContextMenu = this.openContextMenu.bind(this);

    //Undo/Redo
    this.saveUndoState = this.saveUndoState.bind(this);
    this.undo = this.undo.bind(this);
    this.redo = this.redo.bind(this);

    //Utilites

    this.latestSelection = this.latestSelection.bind(this);
    this.isPointInsideCanvas = this.isPointInsideCanvas.bind(this);
    this.resizeSelectedElementsDelta =
      this.resizeSelectedElementsDelta.bind(this);
    this.autoToggleRightPanel = this.autoToggleRightPanel.bind(this);
    this.getWBComponentDataFromId = this.getWBComponentDataFromId.bind(this);
    this.addNewSectionNexToOther = this.addNewSectionNexToOther.bind(this);

    //API calling
    this.trySavePage = this.trySavePage.bind(this);
    this.saveCurrentPageAsync = this.saveCurrentPageAsync.bind(this);
    this.SaveCurrentBlogPostAsync = this.SaveCurrentBlogPostAsync.bind(this);
    this.tryPublishPage = this.tryPublishPage.bind(this);
    this.updateAutoSaveSettings = this.updateAutoSaveSettings.bind(this);

    this.tryLoadPage = this.tryLoadPage.bind(this);
    this.loadPageAsync = this.loadPageAsync.bind(this);

    this.loadBlogPostAsync = this.loadBlogPostAsync.bind(this);
    //menu states
    this.openToPannelMenu = this.openToPannelMenu.bind(this);
    this.switchToMenuState = this.switchToMenuState.bind(this);
    this.openTemplateMenu = this.openTemplateMenu.bind(this);
    this.activateAllForms = this.activateAllForms.bind(this);

    this.OpenImagePicker = this.OpenImagePicker.bind(this);

    (window as any).openImagePicker = this.OpenImagePicker;

    this.initBlogPageLayout = this.initBlogPageLayout.bind(this);
    //init calls
    this.fillLayoutNodeDictionaryRecursive(
      this.layoutNodeDictionary,
      newLayout
    );
    this.saveUndoState(false);

    this.setCanvasScale = this.setCanvasScale.bind(this);
  }
  /********************************
   *                               *
   *       REACT FUNCTIONS         *
   *                               *
   ********************************/
  getPreviewLink() {
    return (
      "/preview/" +
      this.props.siteData.userContext.styleId +
      "/" +
      this.props.siteData.userContext.layoutId +
      "/" +
      this.state.currentPageId
    );
  }

  setCanvasScale(scale: number) {
    if (scale < 0.25) scale = 0.25;
    else if (scale > 1) scale = 1;

    this.setState({ canvasScale: scale });
  }

  OpenImagePicker(onSelect:(url:string,data?:any)=>void){

    let popup = document.getElementById("image-pop-up");
    if(!popup){
      popup = document.createElement("div");
      popup.id = "image-pop-up";
      document.body.appendChild(popup);
    }

    if(popup)
    ReactDOM.render(<TextEditorImagePopUp onClose={()=>{
      if(popup)
      ReactDOM.unmountComponentAtNode(popup);
    }}

    toggleLoading={this.toggleLoading}
    onAddImage={onSelect}

    siteData={this.props.siteData} context={this.props.siteData.userContext}  />,popup);

  }

  createDefaultLayout() {
    let newLayout = CreateBlankLayoutNode(wBComponentTypeNames.pageRoot);

    newLayout.children.push(
      CreateBlankLayoutNode(wBComponentTypeNames.navigationBar)
    );

    let footer = CreateBlankLayoutNode(wBComponentTypeNames.footer);

    newLayout.children.push(footer);

    return newLayout;
  }

  render(): ReactNode {


    const params = window.location.search;

    let initalTabState = 1;
    // let initialMenuState = 0;
   // let initialSelection = -1;
    if (params.includes("menu=sitestyling")) {
      initalTabState = 0;
      //initialMenuState = 1;
      // let location = window.location.href.replace("?menu=sitestyling","");
      // window.history.replaceState(null, "",  location);
      if(this.props.siteData.userContext.isAdmin)
        this.saveType = SaveType.Style;
      //initialSelection = 0;
    } else if (
      params.includes("menu=layout") &&
      this.props.siteData.userContext.isAdmin
    ) {
      this.saveType = SaveType.Layout;
    } else if (params.includes("menu=pages")) {
      initalTabState = 1;
      let location = window.location.href.replace("?menu=pages", "");
      window.history.replaceState(null, "", location);
    }

    // let windowLocationnew = window.location.href;
    // let folder = windowLocationnew.indexOf("admin/") > 0 ? "admin" : "business";
    // let styleid = this.props.styleId;
    // let layoutid = this.props.layoutId;
    // let reactBusinessId = this.props.reactBusinessId;
    let businssName = this.props.businessName;

    let DomainButton = this.DomainButtonRef;
        (window as any).ClicktoDomains = function (this) {
            if (DomainButton.current) {
                DomainButton.current.click();
            }
        };

    // const SettingItems = () => {
    //   return (
    //     <Fragment>
    //       <div className="vg-tab-item tab-pane active show">
    //         <h2 className="tab-title panel-heading">Settings</h2>
    //         <div className="tab-links">
    //           {reactBusinessId > 0 && (
    //             <>
    //               <button
    //                 className={
    //                   "invisible-button tab-link " +
    //                   (this.state.panelMenuState ==
    //                   PanelMenuState.GeneralSettings
    //                     ? "active"
    //                     : "")
    //                 }
    //                 onClick={() => {
    //                   this.openToPannelMenu(PanelMenuState.GeneralSettings);
    //                 }}
    //               >
    //                 General
    //               </button>
    //               <button
    //               ref={this.DomainButtonRef}
    //                 className={
    //                   "invisible-button tab-link " +
    //                   (this.state.panelMenuState == PanelMenuState.Domains
    //                     ? "active"
    //                     : "")
    //                 }
    //                 onClick={() => {
    //                   this.openToPannelMenu(PanelMenuState.Domains);
    //                 }}
    //               >
    //                 Domains
    //               </button>
    //               <NavLink
    //                 className={"tab-link"}
    //                 to={{
    //                   pathname: `${
    //                     "/" +
    //                     folder +
    //                     "/" +
    //                     styleid +
    //                     "/" +
    //                     layoutid +
    //                     "/changestyle"
    //                   }`,
    //                 }}
    //               >
    //                 Change Theme
    //                 Change Theme
    //               </NavLink>
    //               <NavLink
    //                 className={"tab-link"}
    //                 to={{
    //                   pathname: `${
    //                     "/" +
    //                     folder +
    //                     "/" +
    //                     styleid +
    //                     "/" +
    //                     layoutid +
    //                     "/changelayout"
    //                   }`,
    //                 }}
    //               >
    //                 Change Layout
    //               </NavLink>
    //               <button
    //                 className={
    //                   "invisible-button tab-link " +
    //                   (this.state.panelMenuState ==
    //                   PanelMenuState.Multilocation
    //                     ? "active"
    //                     : "")
    //                 }
    //                 onClick={() => {
    //                   this.openToPannelMenu(PanelMenuState.Multilocation);
    //                 }}
    //               >
    //                 Multi-Location
    //               </button>
    //             </>
    //           )}
    //           <button
    //             className={
    //               "invisible-button tab-link " +
    //               (this.state.panelMenuState == PanelMenuState.EditorSettings
    //                 ? "active"
    //                 : "")
    //             }
    //             onClick={() => {
    //               this.openToPannelMenu(PanelMenuState.EditorSettings);
    //             }}
    //           >
    //             Editor Preferences
    //           </button>
    //         </div>
    //       </div>
    //     </Fragment>
    //   );
    // };

    const colorTheme =
      EditorColorThemes[this.props.siteData.editorSettings.editColorIndex];
    let translation = this.state.canvasScale == 0.5 ? "50%" : "16.6666%";

    // const bComponentList:string[] = []
    // const willShowOnSite = PageWillShowOnLive(this.props.siteData,this.state.layout,bComponentList)

    return (
      <>
        {
          <style>
            {`
                    :root{

                        --outline-transparent: ${colorTheme.primary}77 !important;
                        --outline-primary: ${colorTheme.primary} !important;
                        --outline-hover: ${colorTheme.highlight} !important;
                    }
                `}
          </style>
        }

        <GetFontIncludes
          siteData={this.props.siteData}
          root={this.state.layout}
        />
        <div id="render-holder" style={{ display: "none" }}></div>
        <div
          className={
            "main-grid-container " +
            (this.state.rightPannelExpanded ? "" : " no-right ") +
            (this.state.leftPannelExpaned ? "" : " no-left ")
          }
        >
          <div className="grid-top">
            <div className="builder-header editor-header">
              <div className="vagaro-logo-leftnav">
                <a href="/" className="toggleimg">
                  <img alt='vagaro logo' src="https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/VagaroLogo_wb.svg" />
                </a>
                <div className="logo-business">{businssName}</div>
                <div>
                  <PageSelectMenu
                    designer={this}
                    siteData={this.state.siteData}
                    currentPage={this.state.currentPageId}
                    key={
                      "cur-" +
                      this.state.currentPageId +
                      this.state.isLoading +
                      this.props.siteData.pages.length +
                      this.state.pageSelectKey
                    }
                  />
                </div>
              </div>
            </div>

            {/* use the loading state as a key so that each time we update or load a new page the select menu gets updated*/}

            <SizePreviewMenu
              currentPreviewState={this.state.screenSize}
              onChange={this.setPreviewState}
            />

            <SaveAndPublishMenu designer={this} inSaveState={this.saveState} />
          </div>
          <div className="  grid-left ">
            <div className="flex-row w-full h-full" >
            <div
              className="grid-left-inner relative h-full w-full"
              style={{ overflow: "auto" }}
            >
              <div className="mobile-business-name">
                {this.props.businessName}
              </div>
              <div className="nice-scroll">
                <LeftPanel
                  designer={this}
                  businessName={businssName}
                  onChange={() => {
                    if (this.state.panelMenuState != 0)
                      this.openToPannelMenu(0);
                  }}
                  initialState={initalTabState}
                  design={
                    <ComponentDesignPanel
                      manager={this}
                      layout={this.state.layout}
                    />
                  }


                  settings={
                    <>
                      <SettingsMenuRedo
                        designer={this}
                        startInStyle={window.location.href.includes(
                          "menu=sitestyling"
                        )}
                      />
                      {/* <StyleSettingsMenu key={"design-menu"} wBManager={this} layout={this.state.layout} startInState={initialMenuState} otherSettings={<SettingItems />} startInSelection={initialSelection} /> */}
                    </>
                  }
                  pages={
                    <PagesMenu
                      key={this.state.pageMenuLoadToggle.toString() + " pages" + (this.state.mode == EditorMode.Blogging?"blog":"")}
                      siteData={this.props.siteData}
                      webDesigner={this}
                    />
                  }
                />
              </div>
            </div>
            <div className="need-help-drop">
              <button type="button" className="invisible-button send-feedback-editor-btn">Need Help?</button>
              <div className="need-dropdown">
                  <a href="/admin/designservicepage" target="_blank" rel="noreferrer" className="need-link">Get Our Design Team to Build It</a>
                  {/* Add MySite: Link to Webinar */}
                  <a href={`${utils.MySiteName()}/vagarouniversity`} target="_blank" rel="noreferrer" className="need-link">Get a Crash Course</a>
                  <a href="https://support.vagaro.com/hc/en-us/categories/20043786980251?_gl=1*jisjui*_gcl_au*MTMyNjg2MjYzNy4xNzA5NjczNzAx*_ga*MTY0MTcyMzI0MC4xNjY5Njc3NDgz*_ga_BGSFEW1QY1*MTcxMDI3ODU0Mi45NTQuMS4xNzEwMjc5NDM2LjU1LjAuMA" rel="noreferrer" target="_blank" className="need-link">View Support Articles</a>
                  <a href="https://form.asana.com/?k=VTzMLzamWdeQN006ciYNYA&d=35883393372079" target="_blank" rel="noreferrer" className="need-link">Send Feedback</a>
              </div>
            </div>


          <PanelCollapser  inversed = {true} toggleFunction={()=>{this.setState({leftPannelExpaned:!this.state.leftPannelExpaned})}}/>

            </div>
          </div>
          <div
            className=" grid-center editor-pattern-bg"
            ref={this.canvasRef}
            onPointerDown={this.onCanvasClick}
          >
            <div id="toast-root"></div>

            {this.state.editSate === EditorState.EditingContent &&
              this.latestSelection()?.dom && (
                <>
                <InlineTextEditorWrapper
                userContext={this.props.siteData.userContext}
                 key = {this.latestSelection()?.layout.id}
                  dom={this.latestSelection()!.dom}
                  node={this.latestSelection()?.layout}
                  siteData={this.props.siteData}
                  context={this.props.siteData.userContext}

                />
                  {/* <InlineTextEditor
                    key={this.latestSelection()?.layout.id}
                    dom={this.latestSelection()?.dom}
                    node={this.latestSelection()?.layout}
                  /> */}
                </>
              )}
            {this.state.canvasScale != 1 && (
              <style>
                {`#v-canvas .v-site-main-content-container {
                        transform: scale(${
                          this.state.canvasScale
                        }) translateY(-${translation});
                        width: ${100 / this.state.canvasScale}% !important;
                    }
                    .add-section-button{
                        display:none;
                    }

                    #v-canvas .v-footer{
                        transform: scale(${
                          this.state.canvasScale
                        }) translateY(${translation});
                        width: ${100 / this.state.canvasScale}% !important;
                    }
                    `}
              </style>
            )}
            {/* {!willShowOnSite &&

                <div className="hide-page-alert">This page will be hidden on your published site because your business does not have {
                    bComponentList.map((item,index)=>{
                        return <span key={index}><b>{GetWBComponentByTypename(item).displayName}</b> {index<bComponentList.length-1?", ":" "}</span>
                    })
                }</div> */}

            <WBCanvas
              onUpdateDropTargets={() => {
                const canv = this.canvasRef.current ?? document.body;
                this.availableDropTargets =
                  canv.querySelectorAll(".drop-target");
              }}
              isDragging={this.state.editSate == EditorState.Dragging}
              layout={this.state.layout}
              onScrollFunc={() => {
                this.calculateHoveredElement();
              }}
              editorState={this.state.editSate}
              wbManager={this}
              previewState={this.state.screenSize}
              canvasRef={this.canvasRef}
              siteData={this.props.siteData}
            >
              {this.state.editSate === EditorState.Normal && (
                <HoveredOutline webDesigner={this} />
              )}

              {this.state.selectedTargets.length > 0 &&
                this.state.editSate !== EditorState.Dragging && //for each selected element render a new selection outline
                this.state.selectedTargets.map((sel, index) => (
                  <SelectedOutline
                    startAbsMoveFunction={this.startAbsoluteMove}
                    screenSize={this.state.screenSize}
                    canvasRef={this.canvasRef}
                    editorState={this.state.editSate}
                    selectedTarget={sel}
                    key={index}
                    startResizeFunction={this.startResize}
                  />
                ))}


{this.state.styleMenuState == StyleBuilderState.CookieBanner &&
    <>
                <div className="resizable-container w-full" style={{position:"sticky",bottom:"0",zIndex:121}}>
                  <RenderCookieBanner node = {this.props.siteData.siteStyling.cookieBanner}/>
                  </div>
                  </>

        }
{this.state.styleMenuState == StyleBuilderState.Popup &&
    <>
                <div className="resizable-container w-full" style={{position:"sticky",bottom:"50%",left:"0",zIndex:121}}>
                  <RenderPopup
                  onEnable={()=>{
                    setNodeComponentAttributeValue(this.props.siteData.siteStyling.popup,"popup-enabled","enabled");
                    this.props.siteData.onUpdateStyle();
                    this.styleBuilder?.forceUpdate();
                    this.forceUpdate();
                  }}
                  onDismiss={()=>{

                    this.switchToEditorState(EditorState.Normal)

                    this.openToPannelMenu(PannelMenuType.None);

                    this.switchToMenuState(StyleBuilderState.SelectedComponent);
                    this.setState({rightPannelExpanded:false});

                  }}

                  isPreview={true}  userContext={this.props.siteData.userContext} component={this.props.siteData.siteStyling.popup}/>
                  </div>
                  </>

        }


            </WBCanvas>
            {this.state.editSate === EditorState.Dragging && (
              <DraggedComponent
                wbManager={this}
                draggedObject={this.state.draggedLayoutNode}
                mouseX={this.mouseX}
                mouseY={this.mouseY}
              />
            )}


            <div
              id="left-flyout"
              className={
                "left-flyout nice-scroll block-edit " +
                (this.state.panelMenuState != PanelMenuState.None
                  ? "expanded"
                  : "")
              }
            >
              {this.state.editSate == EditorState.InPannelMenu && (
                <>
                  {this.state.panelMenuState ==
                    PanelMenuState.GeneralSettings && (
                    <GeneralSettings
                      onSaveComplete={() =>
                        this.openToPannelMenu(PanelMenuState.None)
                      }
                      hidePannel={true}
                      onCancel={() => {
                        this.openToPannelMenu(PanelMenuState.None);
                      }}
                    />
                  )}

                  {this.state.panelMenuState == PanelMenuState.Domains && (
                    <DomainMenus />
                  )}

                  {this.state.panelMenuState ==
                    PanelMenuState.EditorSettings && (
                    <EditorSettings siteData={this.props.siteData} />
                  )}

                  {this.state.panelMenuState == PanelMenuState.Multilocation && (
                   <>
                   <div className="block-edit" style={{width: "100vw", background: "none", height: "100vh", position: "fixed", left: "1000px", zIndex: "100", top:" 0px"}}></div>
                   <Multilocation designer={this}  Mode={1} dispatch={this.state.dispatch}
                    onCancel={() => {
                      this.openToPannelMenu(PanelMenuState.None);
                    }} />
                    </>
                  )}
                </>
              )}
            </div>
          </div>
          {
            this.state.editSate === EditorState.TemplateMenu &&
              this.templateNode &&

              <>
              { (this.props.siteData.userContext.userType == LoginUserType.VagaroAdmin||ShowSectionTemplatesToBusinessUsers)?
            <SectionTemplateMenu siteData={this.props.siteData} onDismiss={()=>{

              if(this.templateNode){
                this.deleteObjectById(this.templateNode.id);
              }
              this.switchToEditorState(EditorState.Normal)}}

                onSelect={(selectedNode)=>{
                    this.switchToEditorState(EditorState.Normal)
                    //break all references by stringifying then re-parsing
                    let str = stringifyLayout(selectedNode);
                    let newNode = this.convertLayoutStringToLayoutNode(str);

                    let node = this.templateNode;
                    if(!newNode||!node){
                        return;
                    }


                    newNode.parent = node.parent;
                    let index = node.parent?.children.indexOf(node)??0;
                    if(node.parent)
                    node.parent.children[index] = newNode;

                    this.setState({layout:this.state.layout});//reupdate with new layout

                    setTimeout(()=>{ if(newNode){
                      this.saveUndoState();
                      let dom = document.getElementById(newNode.id);
                      if(dom){
                        (dom as HTMLElement).scrollIntoView({behavior:"smooth",block:"center"});
                      }
                      this.selectElementByLayoutObj(newNode);
                    }},0);


                }}

            />
              :
          <WBComponentTemplateMenu
                  node={this.templateNode}
                  designer={this}
                  onClose={() => {
                    this.switchToEditorState(EditorState.Normal);
                  }}
                />
  }
                </>
          }
          <div className=" grid-right">
            <div className="flex-row h-full">
              {!this.state.rightPannelExpanded && (
                <button
                  className="panel-colapse-button block-edit"
                  onClick={(e) => {
                    this.setState({
                      rightPannelExpanded: !this.state.rightPannelExpanded,
                    });
                  }}
                >
                  {" "}
                  <HoverToolTip text="Expand component settings" />{" "}
                  <div
                    className="center-all"
                    style={{ height: ".75em", width: ".75em" }}
                  >
                    <LeftCaret />
                  </div>
                </button>
              )}
               {!this.state.leftPannelExpaned && (
                <button
                  className="panel-colapse-button block-edit"
                  style={{right:"auto",left:"14px"}}
                  onClick={(e) => {
                    this.setState({
                      leftPannelExpaned: !this.state.leftPannelExpaned,
                    });
                  }}
                >
                  {" "}
                  <HoverToolTip text="Expand settings" forceHug={0} />{" "}
                  <div
                    className="center-all"
                    style={{ height: "1em", width: "1em" }}
                  >
                    <GearIcon />
                  </div>
                </button>
              )}

              <PanelCollapser
                toggleFunction={() =>
                  this.setState({
                    rightPannelExpanded: !this.state.rightPannelExpanded,
                  })
                }
              />
              <StyleBuilder
                siteData={this.props.siteData}
                key={this.latestSelection()?.layout.id ?? "stylebuilder"}
                styleEditState={this.state.styleMenuState}
                screenSize={this.state.screenSize}
                components={this.state.selectedTargets}
                manager={this}
              />
            </div>
          </div>
        </div>

        {this.state.editSate === EditorState.Preview && (
          <PreviewScreen
            root={this.state.layout}
            webDesigner={this}
            siteData={this.props.siteData}
          />
        )}

        {this.state.isLoading && <Loader />}
      </>
    );
  }
  componentDidMount(): void {
    /** Touch Events hoisted to be handled By WebDesignManager to ensure correct firing order**/

    (window as any).webDesigner = this;

    document.addEventListener("dragstart", this.handlePreventBrowserDrag);

    document.addEventListener("keydown", this.handleKeyPressEvent);

    document.addEventListener("mousedown", this.handleMouseDown);

    document.addEventListener("pointerup", this.handleMouseUp);

    document.addEventListener("pointermove", this.handleMouseMovement);

    document.addEventListener("scroll", this.handleScroll);

    document.addEventListener("dblclick", this.handleDoubleClick);


    (window as any).saveUndoState = ()=>{this.saveUndoState(true)}

    // document.addEventListener("paste", this.handlePasteAction);

    document.addEventListener("contextmenu", this.handleContextClick);

    this.saveIntervalId = setInterval(() => {
      this.trySavePage(false, true);
    }, this.props.siteData.editorSettings.autoSaveFrequency * 1000);
  }

  handleContextClick(e: any) {
    if (
      this.state.editSate === EditorState.Normal &&
      this.isPointInsideCanvas(e.clientX, e.clientY)
    ) {
      let opened = document.getElementById("opened-context-menu"); // ignore if context menu is already open
      if (opened) return;

      let dom = this.calculateHoveredElement();

      let layoutObj = this.getLayoutNodeById(dom?.id ?? "");
      if (layoutObj) {
        e.preventDefault();
        this.selectElement(dom);
        this.openContextMenu(e.clientX, e.clientY, layoutObj);
      }
    }
  }

  updateAutoSaveSettings() {
    clearInterval(this.saveIntervalId);

    if (this.props.siteData.editorSettings.autoSave)
      this.saveIntervalId = setInterval(() => {
        this.trySavePage(false, true);
      }, this.props.siteData.editorSettings.autoSaveFrequency * 1000);
  }

  componentWillUnmount(): void {
    document.removeEventListener(
      "dragstart",
      this.handlePreventBrowserDrag,
      false
    );

    document.removeEventListener("mousemove", this.handleMouseMovement, false);

    document.removeEventListener("keydown", this.handleKeyPressEvent, false);

    document.removeEventListener("mousedown", this.handleMouseDown, false);

    document.removeEventListener("mouseup", this.handleMouseUp, false);

    document.removeEventListener("scroll", this.handleScroll, false);

    document.removeEventListener("dblclick", this.handleDoubleClick, false);

    // document.removeEventListener("paste", this.handlePasteAction, false);

    document.removeEventListener("contextmenu", this.handleContextClick, false);

    clearInterval(this.saveIntervalId);
    clearInterval(this.autoScrollIntervalId);
  }

  canv: HTMLElement | null = null;

  tryAutoScroll() {
    if (this.state.editSate != EditorState.Dragging) return;

    if (!this.canv) this.canv = document.getElementById("v-canvas");
    if (!this.canv) return;

    let bounds = this.canv.getBoundingClientRect();
    let dir = 0;

    let perc = window.innerHeight * 0.1;

    if (this.mouseY < bounds.top + perc) {
      dir = -1;
    } else if (this.mouseY > bounds.bottom - perc) {
      dir = 1;
    } else {
      this.canv.style.scrollBehavior = "smooth";
    }

    if (dir != 0) {
      this.canv.style.scrollBehavior = "unset";
      this.canv.scrollBy({
        top: 10 * dir,
        left: 0,
        behavior: "auto",
      });
    }
  }

  componentDidUpdate(
    prevProps: Readonly<WebDesignerProps>,
    prevState: Readonly<WebDesignerState>,
    snapshot?: any
  ): void {


    if(prevState.mode != this.state.mode){ // when switching to blogging mode mark section and columns as static for blogging so user can't remove
      ToggleComponentStaticForBlogging(this.state.mode == EditorMode.Blogging);
    }

    if (this.state.editSate === EditorState.Dragging) {
      //&& prevState.hoveredDom !== this.hoveredDom) {

      if (this.state.draggedLayoutNode === null) return;

      let baseElem = this.hoveredDom;

      this.activateClosestDropPoint(
        baseElem,
        this.mouseX,
        this.mouseY,
        this.draggedDropList
      );
    }
  }

  openToPannelMenu(pannelState: PanelMenuState) {



    const check = ()=>{
        if (
          pannelState == PanelMenuState.None &&
          this.state.editSate == EditorState.InPannelMenu
        ) {
          this.setState({ panelMenuState: PanelMenuState.None });
          this.switchToEditorState(EditorState.Normal);
        } else {
          this.setState({ panelMenuState: pannelState });
          if (pannelState != PanelMenuState.None)
            this.switchToEditorState(EditorState.InPannelMenu);
        }
    }

    if(this.panelMenuLocked){
      this.promptForPanelExit(check);
    }
    else
      check();
  }

  getLayoutWithoutHeaderAndFooter(root: LayoutNode) {
    let newLayout: LayoutNode = { ...root };
    newLayout.children = [...root.children];
    if (newLayout.children[0].typename === wBComponentTypeNames.navigationBar)
      newLayout.children.splice(0, 1);

    if (
      newLayout.children[newLayout.children.length - 1].typename ===
      wBComponentTypeNames.footer
    )
      newLayout.children.splice(newLayout.children.length - 1, 1);

    return newLayout;
  }

  /********************************
   *       /end REACT FUNCTIONS    *
   ********************************/

  /********************************
   *   *                           *
   *   *   BUILDER FUNCTIONS       *
   *   V                           *
   ********************************/

  trySavePage(
    forceSave: boolean = false,
    autoSave: boolean = false,
    callBack?: Function
  ) {
    if (!this.props.siteData.isModifyAllowed) return;

    if (autoSave && this.props.siteData.editorSettings.autoSave === false  )
      return;

    if (
      this.saveState !== SaveState.InProgress &&
      (this.dirtySave || forceSave) &&
      !this.state.isLoading
    ) {


      if(this.state.mode == EditorMode.Blogging){
        this.SaveCurrentBlogPostAsync(callBack);
      }
      else{
      this.saveCurrentPageAsync(callBack);
      }
    }
  }


  async tryPublishBlogPost(date?:Date) {
    if (!this.props.siteData.isModifyAllowed) return;



    this.toggleLoading(true);
    let html =  PurifyWithAtts( GeneratePublishHTMLString(
          this.state.layout,
          this.props.siteData,
          false,
          true,

        ));

      await this.SaveCurrentBlogPostAsync();
      if(this.state.postInfo.image == ""){
        AlertConfirm("Please add a hero image to your blog post before publishing.");
        this.toggleLoading(false);
        return;
      }
      let styleString = GetBlogStyling(this.props.siteData.siteStyling.blogInfo);
      await PublishBlogStyle(this.props.siteData.userContext,styleString,()=>{},()=>{
        console.error("error publishing blog style")
      });
      await PublishBlogPost(this.props.siteData.userContext,this.state.currentPageId,html,
        (data:any)=>{ //success
          this.toggleLoading(false);
          this.state.postInfo.status = BlogPostStatus.Published;
          if(date){
            Toast("Blog post scheduled for publishing on "+date.toLocaleDateString() + " "+date.toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"}));
          }
          else {

             ToastWithCTA("Your blog post has been published successfully", "Launch Post",()=>{
              let link = "https://"+this.props.siteData.vagaroURL + "/blog-post/"+this.state.postInfo.slug;
              window.open(link,"_blank");
             })


          }

      },(error:any)=>{ // error


        AlertConfirm("There was an error publishing the blog post. Please try again later.");
        this.toggleLoading(false);

      },date);

  }

  async tryPublishPage(
    IsProApp: boolean,
    isSharePreview: boolean = false,
    isProAppCallBcak: any = function () {},
    islaunch: boolean = false
  ) {

    if (this.state.mode == EditorMode.Blogging) {
      this.tryPublishBlogPost();
      return;
    }

    const isFirstPublish =
      !this.props.siteData.lastPublishDate ||
      this.props.siteData.lastPublishDate.length < 3;

    if (!this.props.siteData.isModifyAllowed) return;




    //store the original logo inside the navigation bar separately. Nav bar will be responsible for testing the logo and replacing all instances
    let navNode = this.state.layout.children[0];
    setNodeComponentAttributeValue(navNode,"bLogoTest",this.props.siteData.logoUrl);

    this.toggleLoading(true);

    await SetNodeDomBoundsAsync(this.state.layout, this); // update the height and width of all nodes for correct image sizing during publish

    if (!this.props.siteData.userContext.isAdmin && !isSharePreview) {
      // for users, flag the current page as being published so that it does not get republished with other pages later on
      setNodeComponentAttributeValue(this.state.layout, "vwbpublished", "1");
      setNodeComponentAttributeValue(this.state.layout, "vwbmultipublished", "1");
      this.props.siteData.lastPublishDate = new Date().getTime().toString();
      this.props.siteData.isStyleSaveDirty = true;
    }

    this.toggleLoading(true);
    await this.saveCurrentPageAsync();

    await this.saveCurrentPageAsync(() => {}, isSharePreview);

    let html = this.props.siteData.userContext.isAdmin
      ? stringifyLayout(this.getLayoutWithoutHeaderAndFooter(this.state.layout))
      : GeneratePublishHTMLString(
          this.state.layout,
          this.props.siteData,
          false,
          true
        );

    let headerString = stringifyLayout(this.state.layout.children[0]);
    let footerString = stringifyLayout(
      this.state.layout.children[this.state.layout.children.length - 1]
    );

    //if the header or footer layoutstring is different than what was initially loaded into the editor, then we need to update the header and footer on publish
    if (headerString != this.props.siteData.prevHeader || isSharePreview) {
      this.props.siteData.prevHeader = headerString;
      this.props.siteData.isHeaderPublishDirty = true;
    }

    if (footerString != this.props.siteData.prevFooter || isSharePreview) {
      this.props.siteData.prevFooter = footerString;
      this.props.siteData.isFooterPublishDirty = true;
    }
    //removed the generate css flag since styling will now be applied in global site styling..

    const headerStyling = GetStylingForSingleNode(
      this.state.layout.children[0],
      this.props.siteData,
      "h",
      true
    );
    const footerStyling = GetStylingForSingleNode(
      this.state.layout.children[this.state.layout.children.length - 1],
      this.props.siteData,
      "f",
      true
    );

    let headerHTML = this.props.siteData.userContext.isAdmin
      ? headerString
      : GeneratePublishForSingleNode(
          this.state.layout.children[0],
          this.props.siteData,
          false,
          "h",
          true,
          true
        );
    let footerHTML = this.props.siteData.userContext.isAdmin
      ? footerString
      : GeneratePublishForSingleNode(
          this.state.layout.children[this.state.layout.children.length - 1],
          this.props.siteData,
          false,
          "f",
          true,
          true
        );

  let isPopupEnabled =   getNodeComponentAttributeValue(this.props.siteData.siteStyling.popup,"popup-enabled","") == "enabled";

  let isValidPopup = true;

  let popupLinks =  getNodeComponentAttributeValue(this.props.siteData.siteStyling.popup,"pop-up-valid","")
  if(isPopupEnabled&&popupLinks!=""){
    isValidPopup = false;
  }

  let popupHTML =   isPopupEnabled&&isValidPopup?ReactDOMServer.renderToString(
  <div  {...GetNodeComponenentAttributeBinding(this.props.siteData.siteStyling.popup,false,wBComponentTypeNames.popup)}> </div>):"";

    popupHTML = PurifyWithAtts(popupHTML);

    //include announcement bar & cookie banner on publish
    if (!this.props.siteData.userContext.isAdmin) {
      if (headerHTML.includes("fixed-above")) {
        headerHTML = headerHTML.replaceAll("fixed-above", "");
        headerHTML = `<div class="fixed-above fixed-container">${
          ReactDOMServer.renderToString(
            <>
            <AnnouncementBanner
              pageData={this.props.siteData.pages}
              inId="close-announcement-btn"
              atts={this.props.siteData.siteStyling.announcementBar}
            />

            </>
          ) + headerHTML
        }</div>`;
      } else
        headerHTML = `${
          ReactDOMServer.renderToString(<>
            <AnnouncementBanner
              pageData={this.props.siteData.pages}
              inId="close-announcement-btn"
              atts={this.props.siteData.siteStyling.announcementBar}
            />

              </>
          ) +
          "<!--split-->" +
          headerHTML
        }`;


        footerHTML = `${footerHTML} ${ReactDOMServer.renderToString(<RenderCookieBanner node = {this.props.siteData.siteStyling.cookieBanner} isPublish={true} />)} ${popupHTML}`;
        headerHTML += ReactDOMServer.renderToString(<GetFontIncludes siteData={this.props.siteData} root ={CreateBlankLayoutNode()}  />)
    }



    const result = { error: false, message: "" };
    const promises = [];

    let IsPreview = IsProApp || isSharePreview;


    //Content
    promises.push(
      PublishPage(
        this.props.siteData,
        this.state.currentPageId,
         this.props.siteData.userContext.isAdmin?html: PurifyWithAtts( html),
        headerStyling + "\n" + footerStyling,
        PurifyWithAtts(headerHTML),
        PurifyWithAtts(footerHTML),
        IsPreview,
        (data) => {

          console.log("calculate button alerts");
         let linkResults =  FindMissingLinks(data,GetLinearPageData(this.props.siteData));

          if(linkResults.length>0){

            AlertConfirm(
              <div className="flex-column gap-med">
                <div >Your site was published with the following links missing</div>
                <ul>
                {
                  linkResults.map((item,index)=>{
                    return <li key={index}>{item}</li>
                  })
                }
                </ul>
              </div>
              ,"missing-link","Missing Links");
          }

        },
        (data) => {
          if (data?.status != 200) {
            result.error = true;
          }
        },
        isFirstPublish
      )
    );

    Promise.all(promises)
      .then(() => {
        if (!result.error) {
          this.toggleLoading(false);

          if (this.props.siteData.vagaroURL) {
            let site = this.props.siteData.vagaroURL;
            if (site) {
              site = "https://" + site;
            }


            if(!isValidPopup){
              AlertConfirm("Your Pop-up was not published with your site because your '"+popupLinks+"' is not valid","Pop-up not Published");
            }
           /*  if (isSharePreview) {
              const Requestdata = {} as any;
              Requestdata.ButtonLink = site + "/preview";
              AsyncAjaxPost(
                this.props.siteData.userContext.businessId +
                  "/SendMail/sendPreviewEmail",
                Requestdata,
                this.props.siteData.userContext.accessToken,
                function onSuccess() {}
              );
            } */
            const { IsPurchasedDomain } = store.getState().Business;
            if (!isSharePreview) {
                if (!utils.IsFromProApp()) {
                    ToastWithCTA("Your website has been published successfully", "Launch Website", () => { window.open(site, "_blank") },   "Set Up Domain",()=>{

                        this.openSettingsMenu();
                        setTimeout(()=>{
                            this.openToDomainSettings();
                        },100);

                    },IsPurchasedDomain);
                }
                else{
                    ToastWithPreview("Website has been published.", "Launch Website", () => { utils.CallBackGivenToMobileApp(MobileCallbackTypes.MobileLink, site); });
                }
            }
            else {
                if (!utils.IsFromProApp()) {
                    ToastWithCTA("Preview link has been published successfully", "Go to preview", () => { window.open(site + "/preview", "_blank"); },   "Set Up Domain",()=>{

                        this.openSettingsMenu();
                        setTimeout(()=>{
                            this.openToDomainSettings();
                        },100);

                    },IsPurchasedDomain);

                    window.open(site + "/preview", "_blank")

                } else if (typeof isProAppCallBcak === 'function' && utils.IsFromProApp()) {
                    if (islaunch) {
                        isProAppCallBcak();
                        utils.CallBackGivenToMobileApp(MobileCallbackTypes.MobileLink, site + "/preview");
                    }
                    else {
                        isProAppCallBcak();
                    }
                }
            }
    } else {
            if (isSharePreview) Toast("Preview published successfully");
            else Toast("Page published successfully");
          }

          if (!isSharePreview) this.published = true;

          // this.setState({published:true});
        } else {
          console.warn(result, "result error");
          this.toggleLoading(false);

          AlertConfirm("Failed to publish page, please try again");
        }
      })
      .catch(() => {
        this.toggleLoading(false);
        // this.setState({published:false});
        this.published = false;
        AlertConfirm("Failed to publish page, please try again");
      });
  }

  openContextMenu(x: number, y: number, node: LayoutNode) {

    let def = GetWBComponentByTypename(node.typename); // remove context menu for static components
    if(def.isStatic)
        return;

    let dom = document.getElementById("component-context-menu");
    if (!dom) return;

    const closeMenu = () => {
      if (dom) ReactDOM.unmountComponentAtNode(dom);
    };

    ReactDOM.render(
      <ComponentContextMenu
        posX={x}
        posY={y}
        node={node}
        designer={this}
        closeMenu={closeMenu}
      />,
      dom
    );
  }

  copyComponentAttributes(source: LayoutNode) {
    this.copiedAttributeCollection = new AttributeCollection();
    this.copiedAttributeCollection.screenSizeStyleAttributes[0] = {
      ...source.screenSizeStyleAttributes[0],
    };
    this.copiedAttributeCollection.screenSizeStyleAttributes[1] = {
      ...source.screenSizeStyleAttributes[1],
    };
    this.copiedAttributeCollection.screenSizeStyleAttributes[2] = {
      ...source.screenSizeStyleAttributes[2],
    };
    this.copiedAttributeCollection.componentAttributes = {
      ...source.componentAttributes,
    };
  }

  clearComponentAttributes(target: LayoutNode) {
    target.screenSizeStyleAttributes = [{}, {}, {}];
    target.componentAttributes = {};
    let component = GetWBComponentByTypename(target.typename);
    component.onFirstTimeCreation(target.parent ?? target, target, this);

    this.saveUndoState(true);
    this.updateMasterLayout(); //update entire page to reset style builder values
  }

  pasteComponentAttributes(target: LayoutNode) {
    if (this.copiedAttributeCollection == null) return;

    let component = GetWBComponentByTypename(target.typename);
    for (let i = 0; i < 3; i++) {
      const arr = Object.entries(
        this.copiedAttributeCollection.screenSizeStyleAttributes[i]
      );

      for (let j = 0; j < arr.length; j++) {
        let key = arr[j][0];
        if (!component.editList.includes(key)) continue;

        let val = arr[j][1];
        setNodeStyleAttributeValue(target, i, key, val);
      }
    }

    const arr = Object.entries(
      this.copiedAttributeCollection.componentAttributes
    );
    for (let i = 0; i < arr.length; i++) {
      let key = arr[i][0];
      if (!component.editList.includes(key)) continue;

      let val = arr[i][1];
      setNodeComponentAttributeValue(target, key, val);
    }

    this.saveUndoState(true);
    this.updateMasterLayout(); //update entire page to reset style builder values
  }

  tryLoadPage(pageID: string) {
    if (!this.state.isLoading) this.loadPageAsync(pageID);
  }

  trySwitchPage(pageID: string, onDecline?: () => void,isBlogPage:boolean = false) {
    if (this.state.currentPageId == pageID) {
      return;
    }

    const load = (isBlogPage?this.loadBlogPostAsync:this.loadPageAsync);

    if (
      this.dirtySave &&
      !this.state.isLoading &&
      this.props.siteData.isModifyAllowed
    ) {
      GenericConfirmation(
        "Would you like to save before leaving?",
        () => {
          this.trySavePage(true, false);
          setTimeout(() => {


            load(pageID);
          }, 10);
        },
        () => {
          if (onDecline) onDecline();
        },
        "leave-page-confirmation",
        "Unsaved Changes",
        "Save",
        "Cancel",
        false,
        "Don't Save",
        () => {
          load(pageID);
        }
      );
    } else {
      if (!this.state.isLoading) load(pageID);
    }
  }

  //cache previous ids and names to avoid unnecessary api calls,
  lastPostId:string = "";
  lastPostTagNames:string[] = [];
  lastPostTagIds:string[] = [];

  lastPostCatNames:string[] = [];
  lastPostCatIds:string[] = [];

  async SaveCurrentBlogPostAsync(callBack?:Function){

    let layoutContent = { ...this.state.layout };
    layoutContent.children = [...this.state.layout.children];

    this.updateSaveState(SaveState.InProgress);

    //remove header & footer.
    layoutContent.children.splice(0, 1);
    layoutContent.children.splice(layoutContent.children.length - 1, 1);

    let content =  stringifyLayout(layoutContent);

    let success = true;

    let heading = this.state.layout.children.find((node)=>node.typename == wBComponentTypeNames.blogHeading);
    if(heading){
      ApplyBlogInfoFromHeading(heading,this.state.postInfo);

        let newInfo = {...this.state.postInfo};

        newInfo.readTime = GetReadTime();


        //remap the tags or categories if necessary
        if(this.lastPostId!=newInfo.id || newInfo.tags.join(",")!=this.lastPostTagNames.join(",")){
          this.lastPostTagNames = newInfo.tags;
          await GetBlogTagsOrCategories(true, this.props.siteData.userContext,(data:any)=>{

            newInfo.tags = GetIdListFromChips(newInfo.tags,data);
            this.lastPostTagIds = newInfo.tags;

          },(error)=>{

          });

        }
        else{
          newInfo.tags = this.lastPostTagIds;
        }


        if(this.lastPostId!=newInfo.id || newInfo.category.join(",")!=this.lastPostCatNames.join(",")){
          this.lastPostCatNames = newInfo.category;
          await GetBlogTagsOrCategories(false, this.props.siteData.userContext,(data:any)=>{

            newInfo.category = GetIdListFromChips(newInfo.category,data);
            this.lastPostCatIds = newInfo.category;
          },(error)=>{

          });

        }
        else{
          newInfo.category = this.lastPostCatIds;
        }

        this.lastPostId = newInfo.id;

      await EditPostSettings(this.props.siteData.userContext,this.state.currentPageId,newInfo,(data)=>{},()=>{

        success = false;
        AlertConfirm("Failed to save blog post settings, please try again");
        if(callBack)
          callBack(false);

      });


    }
    else{
      console.error("blog does not have heading")
    }

    //save the blog styling with the site styling..
    await SaveBlogStyling (this.props.siteData.userContext,JSON.stringify(this.props.siteData.siteStyling.blogInfo),(data)=>{},()=>{});


    if(success)
    await SaveBlogPostContent(this.props.siteData.userContext,this.state.currentPageId,content,(data)=>{
      this.updateSaveState(SaveState.Success);
      this.dirtySave = false;
      if(callBack)
        callBack(true); //no error but no promises pushed...
    },()=>{
      this.updateSaveState(SaveState.Error);
      if(callBack)
        callBack(false);

    })

  }

  async saveCurrentPageAsync(
    callBack?: Function,
    isSharePreview: boolean = false
  ) {
    if (
      !this.props.siteData.isModifyAllowed ||
      !this.state.layout ||
      this.state.layout.children.length < 1
    ) {
      if (callBack) callBack();
      return;
    }

    //saftey check to remove location data when saving in admin
    if (this.props.siteData.userContext.isAdmin) {
      ProcessNodes(this.state.layout, (node: LayoutNode) => {
        setNodeComponentAttributeValue(
          node,
          componentAttributeTypes.multiLocation,
          ""
        );
      });
    }

    //this.setState({saveState:SaveState.InProgress});
    this.updateSaveState(SaveState.InProgress);
    let saveStyle =
      this.saveType == SaveType.Style || this.saveType == SaveType.All;
    let saveLayout =
      this.saveType == SaveType.Layout || this.saveType == SaveType.All;

    let layoutContent = { ...this.state.layout };
    layoutContent.children = [...this.state.layout.children];
    let hNode = layoutContent.children[0];
    let fNode = layoutContent.children[layoutContent.children.length - 1];
    let headerContent = stringifyLayout(hNode)?.replaceAll(
      this.props.siteData.logoUrl ?? "$$invalid$$",
      adminLogoData.imagePath
    );
    let footerContent = stringifyLayout(fNode)?.replaceAll(
      this.props.siteData.logoUrl ?? "$$invalid$$",
      adminLogoData.imagePath
    );

    layoutContent.children.splice(0, 1);
    layoutContent.children.splice(layoutContent.children.length - 1, 1);

    if (!isSharePreview){
      setNodeComponentAttributeValue(layoutContent, "vwbpublished", ""); //remove the publish flag on save
      setNodeComponentAttributeValue(layoutContent, "vwbmultipublished", ""); //remove the multi publish flag on save
    }
    let content = stringifyLayout(layoutContent);

    const promises = [];

    const results = {
      errored: false,
    };

    if (
      headerContent != this.prevHeaderSave &&
      saveLayout &&
      headerContent.length > 0
    ) {
      promises.push(
        SaveHeaderAsync(
          false,
          this.props.siteData.userContext,
          headerContent,
          (data) => {},
          () => {
            results.errored = true;
          }
        )
      );
    }

    if (
      footerContent != this.prevFooterSave &&
      saveLayout &&
      footerContent.length > 0
    ) {
      promises.push(
        SaveFooterAsync(
          false,
          this.props.siteData.userContext,
          footerContent,
          (data) => {},
          () => {
            results.errored = true;
          }
        )
      );
    }

    if (this.props.siteData.isStyleSaveDirty && saveStyle && !this.props.siteData.userContext.isAdmin) {
      promises.push(
        SaveSiteStyle(
          this.props.siteData,
          (data) => {


          },
          () => {
            console.log("err");
            results.errored = true;
          }
        )
      );
    }

    if (saveLayout) {
      promises.push(
        SavePageAsync(
          false,
          this.props.siteData.userContext,
          this.state.currentPageId,
          content,
          (data) => {},
          () => {}
        )
      );
    }

    await Promise.all(promises)
      .then(() => {
        if (results.errored) {
          this.updateSaveState(SaveState.Error);
        } else {
          this.prevFooterSave = footerContent;
          this.prevHeaderSave = headerContent;
          this.props.siteData.isStyleSaveDirty = false;

          this.updateSaveState(SaveState.Success);
          this.dirtySave = false;
        }

        if (callBack) {
          callBack(true);
        }
      })
      .catch((e) => {
        if (callBack) {
          callBack(false);
        }

        this.updateSaveState(SaveState.Error);
      });

    if (promises.length < 1 && callBack) {
      this.updateSaveState(SaveState.Success);
      callBack(true); //no error but no promises pushed...
    }
  }



async loadBlogPostAsync(postId: string) {

    this.toggleLoading(true);

    await LoadBlogStyling(this.props.siteData.userContext,(data)=>{

      if(data==""){
        this.props.siteData.siteStyling.blogInfo = new AttributeCollection();
      }
      else{
        try{
        let collection = JSON.parse(data);

        if(!collection||!collection.componentAttributes){ // make sure it's a valid attribute Collection
          this.props.siteData.siteStyling.blogInfo = new AttributeCollection();
        }
        else
          this.props.siteData.siteStyling.blogInfo = collection;
        }
        catch(e){
          console.warn("failed to parse blog styling")
        }
    }

    },(error)=>{
      AlertConfirm("Failed to load blog styling, please try again");
      this.toggleLoading(false);
    });

    LoadBlogEditorDetails(this.props.siteData.userContext,postId,(data)=>{


      let root;
      // let content = data.data.data.content??"";
      if(data.data.data.id){

        let post = GetPostInfoFromResponse(data.data.data);

        this.setState({postInfo:post});

        root = this.convertLayoutStringToLayoutNode(data.data.data.content,false);

        if(!root){
          root = this.createDefaultLayout();
        }

          this.sanityCheck(root);

          let nav = CreateBlankLayoutNode(wBComponentTypeNames.navigationBar);
          let footer = CreateBlankLayoutNode(wBComponentTypeNames.footer);

          if(root.children[0].typename != wBComponentTypeNames.navigationBar){
            root.children.unshift(nav);
          }
          if(root.children[root.children.length-1].typename != wBComponentTypeNames.footer){
            root.children.push(footer);
          }

          this.toggleLoading(false);

          this.setState({
            mode: EditorMode.Blogging,
            layout: root,
            currentPageId: postId,
            selectedTargets: [],
          });

          this.props.siteData.currentPageId = postId;

          this.initBlogPageLayout();


          //init heading atts
          let blogData = data.data.data;
          let blogHeading = root.children.find(x=>x.typename == wBComponentTypeNames.blogHeading);

          if(!blogHeading){
            blogHeading = CreateBlankLayoutNode(wBComponentTypeNames.blogHeading);
            this.moveComponentByObj(blogHeading,root,1,false);
          }





            blogHeading.componentAttributes["blog-title"] = blogData.title;
            blogHeading.componentAttributes["blog-author"] = blogData.author;
            blogHeading.componentAttributes["blog-hero-image"] = blogData.imageURL;

            let blogCollection = this.state.siteData.siteStyling.blogInfo;
            for(let i = 0;i<BlogAndStylingSyncKeys.length;i++){

              let key = BlogAndStylingSyncKeys[i];
              let styleVal = getNodeComponentAttributeValue(blogCollection,key);
              setNodeComponentAttributeValue(blogHeading,key,styleVal);

            }



          setTimeout(()=>{
            this.dirtySave = false;
            this.undoStates = [];
            this.redoStates = [];
            this.updateSaveState(SaveState.Success);
            blogHeading&&blogHeading.forceUpdate&&blogHeading.forceUpdate();
            let title = document.getElementById("blog-heading-input");
            if(title)
              (title as any).value = post.title;
            const canv = document.getElementById("v-canvas");
            if (canv) canv.scrollTop = 0;
          },50);





        }

    },(data)=>{

      AlertConfirm("Failed to load blog content, please try again");
      this.toggleLoading(false);
    },true);


}

async loadPageAsync(pageId: string) {

    SetGlobalCurrentPageId(pageId);

    this.setState({postInfo:CreateGenericPost()})

    let pages = GetLinearPageData(this.props.siteData);
    let pg = pages.find((x) => x.pageId == pageId);



    if(pg){
      SetGlobalCurrentPageData(pg);
      this.props.siteData.userContext.isDuplicateAllLocationPage = pg.isDuplicateAllLocationPage;
    }


    this.props.siteData.currentPageId = pageId;
    this.toggleLoading(true);
    await ValidateToken(this.props.siteData.userContext);
    if (pageId != "") {



      LoadPageContentAsync(
        this.props.siteData.userContext,
        pageId,
        (data) => {
          let layout = this.convertLayoutStringToLayoutNode(
            data.data.data.content,
            false
          );

          if(layout)
          this.sanityCheck(layout);

          let headerString = data.data.data.header ?? "";
          let footerString = data.data.data.footer ?? "";
          this.props.siteData.prevFooter = headerString;
          this.props.siteData.prevHeader = footerString;

          const rplc = this.props.siteData.logoUrl ?? "";

          if (this.props.siteData.logoUrl) {
            headerString = headerString?.replaceAll(
              adminLogoData.imagePath,
              rplc
            );
            footerString = footerString?.replaceAll(
              adminLogoData.imagePath,
              rplc
            );
          }

          //track for saving
          this.prevFooterSave = headerString;
          this.prevHeaderSave = footerString;

          let header = this.convertLayoutStringToLayoutNode(headerString, true);
          if (!header) {
            //auto add business logo to brand new header
            header = CreateBlankLayoutNode(wBComponentTypeNames.navigationBar);
            setNodeComponentAttributeValue(
              header,
              "logo",
              this.props.siteData.logoUrl ?? ""
            );
            setNodeComponentAttributeValue(
              header,
              "mobilelogo",
              this.props.siteData.logoUrl ?? ""
            );
          }

          let footer =
            this.convertLayoutStringToLayoutNode(footerString, true) ??
            CreateBlankLayoutNode(wBComponentTypeNames.footer);

          if (header.children.length > 0) {
            header.children = [];
          }

          if (footer.children.length < 1)
            footer.children.push(
              CreateBlankLayoutNode(wBComponentTypeNames.column)
            );

          if (!layout || layout.children.length < 1)
            //{
            layout = this.createDefaultLayout();

          if (
            layout.children[0].typename !== wBComponentTypeNames.navigationBar
          )
            layout.children.unshift(header);
          else {
            layout.children.shift();
            layout.children.unshift(header);
          }
          if (
            layout.children[layout.children.length - 1].typename !==
            wBComponentTypeNames.footer
          ){

            if(footer.typename !== wBComponentTypeNames.footer){
              footer.typename = wBComponentTypeNames.footer;
            }
            layout.children.push(footer);
          }
          else {

            layout.children.pop();
            layout.children.push(footer);
          }

          this.setState({

            layout: layout as LayoutNode,
            currentPageId: pageId,
            selectedTargets: [],
          });

          this.layoutNodeDictionary = {};

          assignParentsToLayoutRecursive(layout, false);
          this.fillLayoutNodeDictionaryRecursive(
            this.layoutNodeDictionary,
            layout as LayoutNode
          );
          this.undoStates = [];
          this.redoStates = [];

          this.saveUndoState(false);

          this.toggleLoading(false);
          this.props.siteData.onUpdateCustomCSS();

          this.updateSaveState(SaveState.Success);
          this.dirtySave = false;
          //save the page the first time a user loads into an site. this can be determined by a non admin business on the /admin/ path
          if (
            !this.props.siteData.userContext.isAdmin &&
            window.location.href.indexOf("/admin/") > 0 &&
            this.props.siteData.isModifyAllowed &&
            this.props.siteData.pages.length > 0
          ) {
            if (this.firstTimeCompile) {
              this.firstTimeCompile = false;

              const savePageDeffered = ()=>{

                this.saveCurrentPageAsync(() => {

                  GetStyleListForLayoutId(
                    this.props.siteData.userContext,
                    this.props.reactBusinessId,
                    (data) => {
                      let list = data?.data.data?.styleList;
                      list = list.filter(
                        (x: any) => x.businessTemplateIdentity.length > 2
                      );
                      let newLayoutId = list[0].businessTemplateIdentity;
                      if (newLayoutId) {
                        this.props.siteData.userContext.layoutId = newLayoutId;
                        this.props.siteData.pages = [];
                        this.props.siteData.userContext.pages = [];


                        //save formatted styling first
                        SaveSiteStyle(this.props.siteData,()=>{
                            let a = document.createElement("a");

                                a.target = "_self";
                                if (window.location.href.includes("?isProApp=true")) {
                                  a.href =
                                    "/business/" +
                                    this.props.styleId +
                                    "/" +
                                    newLayoutId +
                                    "/designer?isProApp=true";
                                } else {
                                  a.href =
                                    "/business/" +
                                    this.props.siteData.userContext.styleId +
                                    "/" +
                                    newLayoutId +
                                    "/designer";
                                }


                            a.click();
                      },()=>{AlertConfirm("Failed to save style, please try again")});
                      } else {
                        AlertConfirm("Failed to create page, please try again");
                      }
                    },
                    (data: any) => {
                      console.warn("failed to get style list", data);




                      let a = document.createElement("a");

                      a.target = "_self";

                      a.href = window.location.href.split("/admin/")[0];

                      if(window.location.href.includes(setStyleDenotation)){
                        a.href = window.location.href.replace("/admin/","/business/");
                      }

                      a.click();
                    }
                  );
                });
              }

              if(window.location.href.includes(setStyleDenotation)){


                ActivateDefaultStyle(this.props.siteData,(data)=>{

                  CreateSiteStylingFromString(this.props.siteData.userContext,window.location.href,(styling:SiteStyling)=>{

                    this.props.siteData.siteStyling = styling;

                   // this.props.siteData.isStyleSaveDirty = true;
                    savePageDeffered();
                  },()=>{
                    AlertConfirm("Failed to compile styling, please try again");
                  })

                },()=>{

                  AlertConfirm("Failed to compile styling, please try again");

                });


              }

              else{
                savePageDeffered();
              }


              this.firstTimeCompile = false;
            }
          } else if (this.firstTimeLoad) {

            if (window.location.href.includes("isProApp=true")) {
              setTimeout(
                () => this.switchToEditorState(EditorState.Preview),
                0
              );
              //callBck = ()=> this.switchToEditorState(EditorState.Preview);
            }

            this.firstTimeLoad = false;
            this.saveCurrentPageAsync(); //save on the first load each time
          }

          setTimeout(() => {
            const canv = document.getElementById("v-canvas");
            if (canv) canv.scrollTop = 0;
          }, 10);



            this.setState({mode:EditorMode.Normal});


        },
        (data) => {
          this.setState({
            selectedTargets: [],

            currentPageId: pageId,
          });

          AlertConfirm("Failed to load page content, please try again");
          this.toggleLoading(false);
        }
      );




    } else {
      this.toggleLoading(false);
    }

    if(window.location.href.includes(setStyleDenotation)&&this.props.siteData.userContext.isAdmin){

        //if coming in through admin just load the style for this session (does not need to be saved)

        CreateSiteStylingFromString(this.props.siteData.userContext,window.location.href,(styling:SiteStyling)=>{

          this.props.siteData.siteStyling = styling;
          this.props.siteData.onUpdateStyle();

        },()=>{
          AlertConfirm("Failed to compile styling, please try again");
        });

    }

  }


  sanityCheck(node:LayoutNode){
    let ids:string[] = [];
    let pendingList = [node];
    while(pendingList.length > 0){
      let n = pendingList.pop();

      if(!n){
        console.warn("null node");
        continue;
      }

      if(ids.includes(n.id)||!n.id){
        console.warn("duplicate id or null id",n.id);
        n.id = CreateNewGUID();
      }
      ids.push(n.id);
      pendingList.push(...n.children);
    }
  }

  latestSelection() {
    if (this.state.selectedTargets.length < 0) return null;

    return this.state.selectedTargets[this.state.selectedTargets.length - 1];
  }

  needsToFlagDirty = false;

  flagDirtySave() {


    let saveState = this.saveState;

    if (saveState === SaveState.Success) saveState = SaveState.Unsaved;

    if (this.dirtySave === false) {
      this.dirtySave = true;
      this.published = true;
    }
    this.updateSaveState(SaveState.Unsaved);
  }

  undo() {
    if (this.state.editSate === EditorState.EditingContent) {
      const selected = this.latestSelection();
      // if (selected) {
      //   selected.dom.innerHTML = selected.layout.content ?? "";
      // }
      if (selected) {
        const sanitizedContent = selected.layout.content ? sanitize(selected.layout.content) : "";
        selected.dom.innerHTML = sanitizedContent;
      }
    } else if (this.undoStates.length > 1) {
      let state = this.undoStates.pop();
      //since the latest undo state is actually the current state pop it and assign it to the redos
      if (state) this.redoStates.push(state);

      state = this.undoStates[this.undoStates.length - 1];
      if (state) {
        let position = this.canvasRef.current?.scrollTop ?? 0;
        this.loadLayoutStringIntoCurrentState(state);
        setTimeout(() => {
          if (this.canvasRef.current)
            this.canvasRef.current.scrollTop = position;
        }, 100);
      }
      this.props.siteData.onUpdateCustomCSS();
      this.flagDirtySave();
    }
  }

  redo() {
    if (this.redoStates.length > 0) {
      let state = this.redoStates.pop();
      if (state) {
        let position = this.canvasRef.current?.scrollTop ?? 0;
        this.undoStates.push(state);
        this.loadLayoutStringIntoCurrentState(state);

        setTimeout(() => {
          if (this.canvasRef.current)
            this.canvasRef.current.scrollTop = position;
        }, 100);
      }
      this.props.siteData.onUpdateCustomCSS();
      this.flagDirtySave();
    }
  }

  onCanvasClick(e: any) {}

  updateMasterLayout() {
    this.setState({ layout: this.state.layout });
  }
  //needed for cancleling on mobile and firefox
  handlePreventBrowserDrag(e: Event) {
    e.preventDefault();
    e.stopPropagation();
  }

  //intercepts the paste event and removes all formatting, currently relying on depricated execCommand but currently works in all browsers
  // handlePasteAction(e: ClipboardEvent) {
  //   // e.preventDefault();
  //   // var clipboardData = e.clipboardData;
  //   // if(clipboardData){
  //   //     var pastedData = clipboardData.getData('text');
  //   //     //Remove any HTML Mark up, currently uneccessary as the execCommand removes all formatting but depending on browser may be needed
  //   //     // Remove any color formatting from the pasted text
  //   //     //pastedData = pastedData.replace(/<font.*?color="(.*?)".*?>(.*?)<\/font>/gi, '$2');
  //   //     // Insert the cleaned text into the contenteditable DOM
  //   //     document.execCommand('insertHTML', false, pastedData); // execCommand is depreciated!
  //   // }
  // }

  handleTouchUp(e: TouchEvent) {
    if (this.state.editSate === EditorState.Normal) {
      if (this.latestSelection()) {
        let elem = this.calculateHoveredElement();

        if (this.latestSelection()?.layout != this.previousSelection) {
          this.previousSelection = this.latestSelection()?.layout ?? null;
        } else if (
          this.previousSelection != null &&
          elem &&
          elem.id == this.previousSelection.id
        ) {
          this.tryEditContentOfHoveredElement();
        }
      }
    }

    this.mouseIsDown = false;
    this.lastEventWasTouch = true;
  }
  //avoid mobile drag start events by intercepting and preventing default action
  handleTouchStart(e: TouchEvent) {
    this.lastEventWasTouch = true;
    let target = this.latestSelection();

    if (target && target.dom && this.state.editSate === EditorState.Normal) {
      const x = e.touches[0].clientX;
      const y = e.touches[0].clientY;

      let bounds = target.dom.getBoundingClientRect();

      if (
        bounds.left <= x &&
        bounds.right > x &&
        bounds.top <= y &&
        bounds.bottom >= y
      ) {
        this.mouseX = x;
        this.mouseY = y;
        this.mouseDownPoint = { x: x, y: y };
        this.mouseIsDown = true;

        let hdom = this.calculateHoveredElement();

        if (hdom == target.dom) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  }

  autoToggleRightPanel(shouldExpand: boolean) {
    if (
      this.props.siteData.editorSettings.autoExpandCollapseRightMenu &&
      this.state.styleMenuState == 0
    ) {
      this.setState({ rightPannelExpanded: shouldExpand });
      if (!shouldExpand) this.onDeselectMenu();
    }
  }

  handleTouchMove(e: TouchEvent) {
    this.mouseX = e.touches[0].clientX;
    this.mouseY = e.touches[0].clientY;
    this.hoverElement(null);
    if (
      this.state.editSate === EditorState.Dragging ||
      this.state.editSate === EditorState.Resizing ||
      this.state.editSate === EditorState.MovingAbsolute
    ) {
      this.emulateMouseMoveFromTouch(e);
      e.preventDefault();
      e.stopPropagation();
    }
  }

  loadLayoutStringIntoCurrentState(layoutString: string) {
    this.layoutNodeDictionary = {};

    let layoutOBject = this.convertLayoutStringToLayoutNode(
      layoutString,
      false
    );

    if (!layoutOBject) {
      console.error("Invalid layout string");
      return null;
    }

    this.setState({ layout: layoutOBject, selectedTargets: [] });

    return layoutOBject;
  }

  convertLayoutStringToLayoutNode(
    layoutString: string,
    generateIds: boolean = true
  ): LayoutNode | null {
    try {
      let layoutOBject = JSON.parse(layoutString);

      if (!layoutOBject) {
        console.error("please pass valid string");
        return null;
      }
      assignParentsToLayoutRecursive(layoutOBject, generateIds);

      this.fillLayoutNodeDictionaryRecursive(
        this.layoutNodeDictionary,
        layoutOBject
      );
      return layoutOBject;
    } catch (e) {
      console.warn(e);
      console.warn(layoutString);
      return null;
    }
  }

  saveUndoState(flagAsDirty = true) {



    let layoutState = stringifyLayout(this.state.layout);
    if (flagAsDirty) this.flagDirtySave();

    if (
      this.undoStates.length === 0 ||
      this.undoStates[this.undoStates.length - 1] !== layoutState
    ) {
      this.undoStates.push(layoutState);
      this.redoStates = []; //reset the redos on every save state
    }

    if (this.undoStates.length > 100) {
      this.undoStates.shift();
    }
  }

  handleKeyPressEvent(e: KeyboardEvent) {
    if (
      (e.key === "Delete" ||
        (e.key === "Backspace" &&
          document.activeElement?.tagName != "INPUT" &&
          document.activeElement?.tagName != "TEXTAREA")) &&
      this.state.editSate === EditorState.Normal
    ) {
      if (this.state.selectedTargets.length > 0) {
        this.deleteSelectedDoms();
      }
    } else if (
      e.key == "`" &&
      (e.ctrlKey || e.metaKey) &&
      this.props.siteData.userContext.userType === LoginUserType.VagaroAdmin
    ) {
      GetStyleListForLayoutId(this.props.siteData.userContext, this.props.reactBusinessId);
      const sel = this.latestSelection();
      if (sel) {
        const str = stringifyLayout(sel.layout);

        if (sel.layout.typename === wBComponentTypeNames.section) {
          Toast("Section Saved as Template");
          localStorage.setItem("vwbsavedtemplate", str);
        }
      }
    } else if (e.key === "d" && (e.ctrlKey || e.metaKey)) {
      let selection = this.latestSelection();

      if (selection) this.duplicateOjbectInPlace(selection.layout);
      e.preventDefault();
    } else if (e.key === "Escape") {
      this.deselectAll();
    } else if (e.key === "z" || e.key === "Z") {
      if (e.ctrlKey || e.metaKey) {
        //if focused in a text box or area, allow redo/undo to affect the text instead of component changes
        if (
          (document.activeElement?.tagName === "INPUT" &&
            !document.activeElement.matches("[type='range']")) ||
          document.activeElement?.tagName === "TEXTAREA"
        )
          return;

        if (this.state.editSate === EditorState.Normal) {
          e.preventDefault(); //prevent previouslly adjusted input fields from changing states.

          if (e.shiftKey) {
            this.redo();
          } else this.undo();
        }
      }
    } else if (e.key === "s" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      e.stopPropagation();
      this.trySavePage(true);
    }
    else if(e.key === "c" && (e.ctrlKey || e.metaKey)){
      let active = document.activeElement?.tagName.toLocaleLowerCase();
      if(this.state.editSate == EditorState.EditingContent|| !this.latestSelection()||active === "input" || active === "textarea") return;
      e.preventDefault();
      e.stopPropagation();
      let selection =this.latestSelection()?.layout;
      if(selection){

        sessionStorage.setItem("copied-component",stringifyLayout(selection));
      }
    }
    else if(e.key === "v" && (e.ctrlKey || e.metaKey)){
      let active = document.activeElement?.tagName.toLocaleLowerCase();
      if(this.state.editSate == EditorState.EditingContent|| !this.latestSelection()||active === "input" || active === "textarea") return;
      e.preventDefault();
      e.stopPropagation();

      let toPaste = sessionStorage.getItem("copied-component");
      if(toPaste){
        let pasteTo = this.latestSelection()?.layout;
        if(pasteTo)
        this.pasteOjbectInPlace(pasteTo,toPaste);
      }

    }

  }

  setPreviewState(newPreviewState: ScreenSize) {
    this.setState({ screenSize: newPreviewState });
  }

  updateStyleAttributeByValue(
    target: LayoutNode,
    attribute: string,
    value: string
  ) {

    let comp = GetWBComponentByTypename(target.typename);
    if(!comp.editList.includes(attribute))
      return;

    setNodeStyleAttributeValue(target, this.state.screenSize, attribute, value);
  }

  deleteSelectedDoms() {
    let layout = this.state.layout;

    for (let i = 0; i < this.state.selectedTargets.length; i++) {
      let comp = GetWBComponentByTypename(
        this.state.selectedTargets[i].layout.typename
      );
      comp.onPreDeletion(this.state.selectedTargets[i].layout, this);
      this.deleteObjectById(this.state.selectedTargets[i].dom.id);
    }

    if (this.state.selectedTargets.length > 0) this.saveUndoState();

    this.setState({ selectedTargets: [], layout: layout });

    setTimeout(() => {
      this.calculateHoveredElement();
      this.autoToggleRightPanel(false);
    }, 0);
  }

  duplicateOjbectInPlace(layoutObject: LayoutNode | null) {
    let comp = GetWBComponentByTypename(layoutObject?.typename ?? "");
    if (comp && comp.isStatic) {
      return;
    }

    if (!layoutObject || !layoutObject.parent) {
      console.error("Trying to duplicate a null or null parent object");
      return null;
    }

    let newLayoutString: string = stringifyLayout(layoutObject);
    let newLayoutObject = this.convertLayoutStringToLayoutNode(newLayoutString);


    if (newLayoutObject) {

      if(newLayoutObject.typename === wBComponentTypeNames.section){ //remove section template link
        newLayoutObject.content = "";
      }

      const index = layoutObject.parent.children.indexOf(layoutObject);
      this.moveComponentByObj(newLayoutObject, layoutObject.parent, index);
    }

    return newLayoutObject;
  }


  pasteOjbectInPlace(pasteAfter: LayoutNode | null,pasteString:string) {
    let parsed = this.convertLayoutStringToLayoutNode(pasteString);

    let comp = GetWBComponentByTypename(parsed?.typename ?? "");
    if (comp && comp.isStatic) {
      return;
    }

    if (!pasteAfter || !pasteAfter.parent) {
      console.error("Trying to paste a null or null parent object");
      return null;
    }




    if (parsed) {
      let parent = pasteAfter.parent;
      if(parent){


        if(!comp.dropList.includes(parent.typename)){
          WarningToast("Cannot paste here, invalid container type",()=>{});
          return;

        }

      }


      const index = pasteAfter.parent.children.indexOf(pasteAfter);
      this.moveComponentByObj(parsed, pasteAfter.parent, index);
    }

    return parsed;
  }

  getCopyOfLayoutObject(layoutObject: LayoutNode) {
    let newLayoutString: string = stringifyLayout(layoutObject);
    let newLayoutObject = this.convertLayoutStringToLayoutNode(newLayoutString);

    return newLayoutObject;
  }

  handleDoubleClick(e: MouseEvent) {
    this.tryEditContentOfHoveredElement();
  }

  tryEditContentOfHoveredElement(clearContents = false) {
    if (this.state.editSate === EditorState.Normal && this.hoveredDom) {
      let data = this.getWBComponentDataFromId(this.hoveredDom.id);
      if (data && data.contentEditable) {
        this.selectElement(this.hoveredDom, false); // set selection to only the hovered item
        if (this.state.selectedTargets.length > 0) {
          // shoudl be true after selecting the hovered dom

          let target = this.state.selectedTargets[0];
          let component = GetWBComponentByTypename(target.layout.typename);
          if (component.contentEditable) {
            target.dom.contentEditable = "false";
            target.dom.focus();
            // if ( // removed clearing contentes 11/22 so that quill editor can delete text instead
            //   (target.layout.content === editTextPlaceHolder &&
            //     useTextasPlaceHodler) ||
            //   clearContents
            // ) {
            //  // target.dom.innerHTML = "";
            // }
          }

          this.switchToEditorState(EditorState.EditingContent);
        }
      }
    }
  }

  getWBComponentDataFromId(id: string) {
    let layout = this.layoutNodeDictionary[id];

    if (layout) {
      let wbc = GetWBComponentByTypename(layout.typename);
      return wbc;
    }
    return null;
  }

  handleScroll() {
    this.calculateHoveredElement();
  }

  emulateClickFromTouch(e: TouchEvent) {
    let pushEvent = new MouseEvent("mousedown", {
      clientX: e.touches[0].clientX,
      clientY: e.touches[0].clientY,
      button: 0,
    });

    this.handleMouseDown(pushEvent);
  }

  emulateMouseMoveFromTouch(e: TouchEvent) {
    let pushEvent = new MouseEvent("mousemove", {
      clientX: e.touches[0].clientX,
      clientY: e.touches[0].clientY,
    });
    this.handleMouseMovement(pushEvent);
    this.calculateHoveredElement();
  }

  handleMouseDown(e: MouseEvent) {
    if (e.button != 0 || this.state.editSate === EditorState.Locked) return;

    //if we are in the pannel menu and we click outside of it, close the menu
    if (this.state.editSate == EditorState.InPannelMenu) {
      if (e.target) {
        let t = e.target as HTMLElement;
        if (
          t.classList.contains("loaderNew") ||
          ClosestWithClass(t, "filerobot-image-editor-root")

        )
          return;
      }
      let leftFlyout = document.getElementById("left-flyout");

      if (leftFlyout) {
        let bounds = leftFlyout.getBoundingClientRect();

        let x = e.clientX;
        let y = e.clientY;

        if(x==0&&y==0){ // fix for firefox event bug not passing in mouse coords when clicking <option>, use previous coords in this case
          x = this.mouseX;
          y = this.mouseY;
        }

        if (
          bounds.right <x||
          bounds.left >x ||
          bounds.top > y ||
          bounds.bottom < y
        ) {
          let elem = e.target as HTMLElement;

          if (elem) {
            let closestModal =  ClosestWithClass(elem,"vgn-popup");

            if (closestModal) return;
          }
          if (!elem || !elem.classList.contains("tab-link")) {
            e.preventDefault();
            e.stopPropagation();

            if(this.state.panelMenuState != PanelMenuState.Multilocation){

              this.openToPannelMenu(PanelMenuState.None);
              if(!this.panelMenuLocked)
              this.switchToEditorState(EditorState.Normal);
              //if(this.state.styleMenuState == StyleBuilderState.SelectedComponent)
              this.onDeselectMenu();
            }
          }
        }
      }

      return;
    }

    let target = e.target as HTMLElement;

    if (e.button === 0 && this.state.editSate === EditorState.Normal) {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;

      //deselect logic when clicking outside of the canvas

      if (
        target &&
        this.state.selectedTargets.length > 0 && // if something is selected
        (e.clientX < 200 ||
          e.clientY < 50 ||
          target.classList.contains("grid-center")) && // and we clicked outside the canvase
        target.tagName != "BUTTON" &&
        target.tagName != "svg" &&
        target.tagName != "A" &&
        !target.classList.contains("tab-link") // and we arn't clicking a button, link, or an icon
      ) {
        if (!this.shiftKeyIsDown) this.deselectAll();

        return;
      }

      let elem = this.calculateHoveredElement();

      if (elem) {
        this.selectElement(elem, e.shiftKey);
        let id = elem?.id;
        if (id) {
          if (!this.lastEventWasTouch) this.mouseIsDown = true;
          else this.lastEventWasTouch = false;
          this.mouseDownPoint = { x: e.clientX, y: e.clientY };
        }
      } else {
        this.selectElement(null);
      }
    }

    //check the selected elements bounds when editing to determine weather to click away
    else if (this.state.editSate === EditorState.EditingContent) {
      //allow clicking on the outline
      if (this.state.selectedTargets.length === 0) {
        //invalid desect since there isn't any selected Doms
        this.switchToEditorState(EditorState.Normal);
      } else {


        let bounds = this.state.selectedTargets[0].dom.getBoundingClientRect(); //this will always have an entry/not null array
        const bufferSizeX = bounds.width > 5 ? 5 : 0;
        const bufferSizeY = bounds.height > 5 ? 5 : 0;

        let targetElem = e.target as HTMLElement;

        if(ClosestWithClass(targetElem,"block-edit")) return;

        //Check to make sure we aren't simply editing the style...
        if (
          !targetElem ||
          !ClosestWithTag(targetElem,'div')?.classList.contains("block-edit")
        )
          if (
            e.clientX < bounds.left - bufferSizeX ||
            e.clientX > bounds.right + bufferSizeX ||
            e.clientY > bounds.bottom + bufferSizeY ||
            e.clientY < bounds.top - bufferSizeY
          ) {
            this.switchToEditorState(EditorState.Normal);
          }
      }
    }
  }

  handleMouseUp(e: MouseEvent) {
    if (e.button != 0) return;

    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
    this.mouseIsDown = false;

    if (this.state.editSate === EditorState.Dragging) {
      this.activateClosestDropPoint(
        this.hoveredDom,
        e.clientX,
        e.clientY,
        this.draggedDropList
      );
      this.endDrag();
    } else if (
      this.state.editSate === EditorState.Resizing ||
      this.state.editSate === EditorState.MovingAbsolute
    ) {
      this.switchToEditorState(EditorState.Normal);
    } else if (this.state.editSate === EditorState.Normal) {
      if (this.latestSelection()) {
        let elem = this.calculateHoveredElement();

        if (this.latestSelection()?.layout != this.previousSelection) {
          this.previousSelection = this.latestSelection()?.layout ?? null;
        } else if (
          this.previousSelection != null &&
          elem &&
          elem.id == this.previousSelection.id
        ) {
          this.tryEditContentOfHoveredElement();

          let data = this.getWBComponentDataFromId(elem.id);

          if (data && data.vagaroLink) {
            CustomColorToast(
              "This component is synced and must be edited in Vagaro",
              "#f6d645",
              "#333",
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                height="16"
                width="16"
                viewBox="0 0 512 512"
              >
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
              </svg>
            );
            //ToastWithCTA("This component is managed by Vagaro, please edit it in the Vagaro dashboard","Edit in Vagaro",()=>{window.open(data!.vagaroLink,"_blank")} );
          }
        }
      }
    }
  }

  toggleLoading(isLoading: boolean) {
    this.setState({ isLoading: isLoading });
  }

  startResize(
    target: { dom: HTMLElement; layout: LayoutNode },
    resizeType: ResizeType,
    e: PointerEvent | null
  ) {
    if (e) {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
    }

    this.resizeTarget = target;
    this.currentResizeType = resizeType;
    this.switchToEditorState(EditorState.Resizing);
  }

  startAbsoluteMove(
    target: { dom: HTMLElement; layout: LayoutNode },
    e: PointerEvent | null
  ) {
    if (e) {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
    }

    let anchorType = getNodeComponentAttributeValue(
      target.layout,
      "anchorType",
      "top-left"
    );

    const horizontalAtt = anchorType.includes("left")
      ? attributeTypes.left
      : attributeTypes.right;
    const vertialAtt = anchorType.includes("top")
      ? attributeTypes.top
      : attributeTypes.bottom;

    let horizontalValue = getNodeStyleAttributeValue(
      target.layout,
      this.state.screenSize,
      horizontalAtt,
      ""
    );
    let verticalValue = getNodeStyleAttributeValue(
      target.layout,
      this.state.screenSize,
      vertialAtt,
      ""
    );

    let closest = null;

    if (!horizontalValue.includes("px") || !verticalValue.includes("px")) {
      const parent = target.dom.parentElement;
      if (parent) {
        closest = ClosestWithClass(parent,"hierarchy");

        if (closest) {
          let cBounds = closest.getClientRects();
          let tBounds = target.dom.getClientRects();

          if (horizontalValue == "") {
            if (horizontalAtt == "left") {
              horizontalValue =
                Math.round(tBounds[0].left - cBounds[0].left) + "px";
            } else {
              horizontalValue =
                Math.round(cBounds[0].right - tBounds[0].right) + "px";
            }

            setNodeStyleAttributeValue(
              target.layout,
              this.state.screenSize,
              horizontalAtt,
              horizontalValue
            );
          }
          if (verticalValue == "") {
            if (vertialAtt == "top") {
              verticalValue =
                Math.round(tBounds[0].top - cBounds[0].top) + "px";
            } else {
              verticalValue =
                Math.round(cBounds[0].bottom - tBounds[0].bottom) + "px";
            }

            setNodeStyleAttributeValue(
              target.layout,
              this.state.screenSize,
              vertialAtt,
              verticalValue
            );
          }
        }
      }
    }

    this.resizeTarget = target;
    this.switchToEditorState(EditorState.MovingAbsolute);
  }

  handleMouseMovement(e: MouseEvent) {
    //reset the touch flag on all mouse movements
    this.lastEventWasTouch = false;

    let deltaX = e.clientX - this.mouseX;
    let deltaY = e.clientY - this.mouseY;
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;

    this.shiftKeyIsDown = e.shiftKey;

    if (
      this.state.editSate === EditorState.Normal ||
      this.state.editSate === EditorState.Dragging
    ) {
      this.calculateHoveredElement();
    } else this.hoverElement(null);

    if (
      this.state.editSate === EditorState.Resizing &&
      this.resizeTarget !== null
    ) {
      this.resizeSelectedElementsDelta(
        this.currentResizeType,
        deltaX / this.state.canvasScale,
        deltaY / this.state.canvasScale
      );
    } else if (
      this.state.editSate === EditorState.MovingAbsolute &&
      this.resizeTarget !== null
    ) {
      this.moveElementAbsolutely(
        this.resizeTarget.layout,
        deltaX / this.state.canvasScale,
        deltaY / this.state.canvasScale
      );
    } else if (
      this.state.editSate === EditorState.Dragging &&
      this.state.draggedLayoutNode
    ) {
      if (this.draggedRenderComponent) {
        this.draggedRenderComponent.setState({
          mouseX: this.mouseX,
          mouseY: this.mouseY,
        });
      }

      this.activateClosestDropPoint(
        this.hoveredDom,
        this.mouseX,
        this.mouseY,
        this.draggedDropList
      );
    } else if (this.state.editSate === EditorState.Normal) {
      let distanceFromInitalPoint = distanceBetweenPoints(
        e.clientX,
        e.clientY,
        this.mouseDownPoint.x,
        this.mouseDownPoint.y
      );

      if (
        this.mouseIsDown &&
        distanceFromInitalPoint >
          this.props.siteData.editorSettings.dragSensitivity
      ) {
        if (this.state.selectedTargets.length > 0) {
          let id = this.state.selectedTargets[0].dom.id;
          if (id) this.startDragFromId(id);
        }
      }
    }
  }

  toggleLayoutMode() {
    this.setState({ layoutMode: !this.state.layoutMode });
  }

  calculateHoveredElement() {
    let x = this.mouseX;
    let y = this.mouseY;

    let b = document.elementsFromPoint(x, y);
    if (b === null) return;

    for (let i = 0; i < b.length; i++) {
      //get top most hierarchy object
      if (b[i].classList.contains(CSSClassNames.overrideHover)) {
        return; // retain the hovered item as it is and allow what is ever overriding it to take control
      }

      if (
        b[i].classList.contains("block-edit") ||
        b[i].classList.contains("modal") ||
        b[i].id === this.state.layout.id ||
        b[i].id == "image-editor-download"
      ) {
        // quick fix for disabling hover events when image editor is open

        this.hoverElement(null);
        return null;
      }

      if (
        b[i].classList.contains("hierarchy") ||
        b[i].classList.contains("can-drop")
      ) {
        //hover the rowlist if nessicary

        this.hoverElement(b[i] as HTMLElement);

        return b[i] as HTMLElement;
      }
    }

    this.hoverElement(null);
    return null;
  }

  isPointInsideCanvas(x: number, y: number) {
    if (this.canvasRef.current == null) return false;

    const cBounds = this.canvasRef.current.getBoundingClientRect();

    return !(
      x < cBounds.left ||
      x > cBounds.right ||
      y > cBounds.bottom ||
      y < cBounds.top
    );
  }

  moveElementAbsolutely(target: LayoutNode, deltaX: number, deltaY: number) {
    let anchorType = getNodeComponentAttributeValue(
      target,
      "anchorType",
      "top-left"
    );

    const horizontalAtt = anchorType.includes("left")
      ? attributeTypes.left
      : attributeTypes.right;
    const vertialAtt = anchorType.includes("top")
      ? attributeTypes.top
      : attributeTypes.bottom;

    let horizontalValue = getNodeStyleAttributeValue(
      target,
      this.state.screenSize,
      horizontalAtt,
      "0px"
    );
    let verticalValue = getNodeStyleAttributeValue(
      target,
      this.state.screenSize,
      vertialAtt,
      "0px"
    );

    if (horizontalAtt == "right") deltaX *= -1;
    if (vertialAtt == "bottom") deltaY *= -1;

    let hNum = parseFloat(horizontalValue);
    let vNum = parseFloat(verticalValue);

    if (!isNaN(hNum)) {
      hNum += deltaX;

      horizontalValue = hNum + "px";
    }
    if (!isNaN(vNum)) {
      vNum += deltaY;
      verticalValue = vNum + "px";
    }
    if (this.resizeTarget?.dom)
      this.resizeTarget.dom.style.transition = "none !important";

    setNodeStyleAttributeValue(
      target,
      this.state.screenSize,
      horizontalAtt,
      horizontalValue
    );
    setNodeStyleAttributeValue(
      target,
      this.state.screenSize,
      vertialAtt,
      verticalValue
    );
    if (
      getNodeStyleAttributes(target, this.state.screenSize).position !=
      "absolute"
    ) {
      setNodeStyleAttributeValue(
        target,
        this.state.screenSize,
        attributeTypes.position,
        "absolute"
      ); //force absolute incase we are overiding via mobile view
      this.updateMasterLayout();
      //update entire layout to force the style builder to update to absolute as well
    } else if (target.forceUpdate) {
      target.forceUpdate();
    } else {
      this.updateMasterLayout();
    }
  }

  resizeSelectedElementsDelta(
    resizeType: ResizeType,
    deltaX: number,
    deltaY: number
  ) {
    const minSize = 5;
    const scl = this.state.canvasScale;
    if (this.resizeTarget == null) return;

    let elem = this.resizeTarget.dom;

    if (elem === null) {
      this.switchToEditorState(EditorState.Normal);
      return;
    }

    let lockedRatio = parseFloat(
      getNodeComponentAttributeValue(
        this.resizeTarget.layout,
        elementResizeLockedKey,
        "0"
      )
    );
    let locked = lockedRatio > 0;

    if (this.shiftKeyIsDown && !locked) {
      locked = true;
      let bounds = elem.getBoundingClientRect();
      lockedRatio = bounds.width / bounds.height;
    }

    let xMult = 0;
    let yMult = 0;

    switch (resizeType) {
      case ResizeType.Left:
        xMult = -1;
        break;
      case ResizeType.Right:
        xMult = 1;
        break;
      case ResizeType.Top:
        yMult = -1;
        break;
      case ResizeType.Bottom:
        yMult = 1;
        break;
      case ResizeType.TopLeft:
        xMult = -1;
        yMult = -1;
        break;
      case ResizeType.TopRight:
        xMult = 1;
        yMult = -1;
        break;
      case ResizeType.BottomLeft:
        xMult = -1;
        yMult = 1;
        break;
      case ResizeType.BottomRight:
        xMult = 1;
        yMult = 1;
        break;

      default:
        break;
    }

    let xRelative = xMult * deltaX;
    let yRelative = yMult * deltaY;

    //resize each element in the multiselect

    let allTargets = [...this.state.selectedTargets];
    const tName = this.resizeTarget.layout.parent?.typename ?? "";
    if (
      (this.resizeTarget.layout.typename === wBComponentTypeNames.column &&
      this.state.screenSize != ScreenSize.Mobile &&
      (tName === wBComponentTypeNames.section ||
        tName === wBComponentTypeNames.navigationBar ||

        tName === wBComponentTypeNames.footer))||

        this.resizeParentList.includes(this.resizeTarget.layout.typename)
    ) {
      let sect = this.resizeTarget.layout.parent;
      let dom = document.getElementById(sect?.id ?? "");

      if (dom && sect) {
        allTargets.push({
          layout: sect,
          dom: dom,
        });
      }
    }


    for (let i = 0; i < allTargets.length; i++) {
      let target = allTargets[i];

      if(  this.resizeParentList.includes(target.layout.typename)){
        continue;
      }

      else if (
        target.layout.typename == wBComponentTypeNames.column &&
        this.state.screenSize != ScreenSize.Mobile

      ) {
        continue;
      }

      let elem = target.dom;
      //let component = GetWBComponentByTypename(target.layout.typename);
      let bounds = elem.getBoundingClientRect();

      let width = bounds.width / scl + xRelative;
      let height = bounds.height / scl + yRelative;
      if (width < minSize) width = minSize;
      if (height < minSize) height = minSize;

      if (locked && lockedRatio !== 0) {
        if (Math.abs(xRelative) > Math.abs(yRelative)) {
          height = width / lockedRatio;
        } else {
          width = height * lockedRatio;
        }
      }

      let newWidth = Math.round(width) + "px";
      let newHeight = Math.round(height) + "px";

      //recalculate the bounds and see if we are fully streched out, if we are simply clear the width
      if (xMult !== 0 || locked) elem.style.width = newWidth;

      if (yMult !== 0 || locked) elem.style.height = newHeight;

      let origWidth = Math.round(bounds.width);
      let origHeight = Math.round(bounds.height);

      bounds = elem.getBoundingClientRect();

      let testWidth = newWidth;
      let testHeight = newHeight;
      if (
        Math.round(bounds.width) <= origWidth &&
        xRelative > 0 &&
        !locked &&
        deltaX > 0
      ) {
        testWidth = "100%";
      }

      if (
        Math.round(bounds.height) <= origHeight &&
        yRelative > 0 &&
        !locked &&
        deltaY > 0
      ) {
        testHeight = "100%";
      }

      if (testHeight != newHeight) {
        elem.style.height = testHeight;
        bounds = elem.getBoundingClientRect();
        if (Math.round(bounds.height) == Math.round(origHeight))
          newHeight = testHeight;
      }
      if (testWidth != newWidth) {
        elem.style.width = testWidth;
        bounds = elem.getBoundingClientRect();
        if (Math.round(bounds.width) == Math.round(origWidth))
          newWidth = testWidth;
      }

      if ((xMult !== 0 && xRelative !== 0) || locked) {
        this.updateStyleAttributeByValue(
          target.layout,
          attributeTypes.width,
          newWidth
        );
        elem.style.width = newWidth;
      }
      if ((yMult !== 0 && yRelative !== 0) || locked) {
        this.updateStyleAttributeByValue(
          target.layout,
          attributeTypes.height,
          newHeight
        );
        elem.style.height = newHeight;
      }

      this.resizeTarget.layout?.forceUpdate &&
        this.resizeTarget.layout.forceUpdate();


    }
  }

  addNewSectionNexToOther(node: LayoutNode) {
    let parent = node.parent;

    if (!parent) return;

    let index = parent.children.indexOf(node) + 1;

    let newNode = CreateBlankLayoutNode(wBComponentTypeNames.section);
    if (!newNode) return;
    this.moveComponentByObj(newNode, parent, index);

    this.openTemplateMenu(newNode);
  }

  switchToMenuState(newState: StyleBuilderState) {
    this.setState({ styleMenuState: newState });
  }
  switchToEditorState(newState: EditorState) {
    if (newState !== this.state.editSate) {
      //this.checkDirty();
      //(window as any).currentvpage = this.props.siteData.currentPageId;
      switch (
        this.state.editSate //compare current state
      ) {
        case EditorState.Dragging:
          this.setState({ draggedLayoutNode: null });

          //clear the active drag targets
          let active = document.querySelectorAll(".drop-target.active"); // clear the active drop point
          for (let i = 0; i < active.length; i++)
            active[i].classList.remove("active");
          break;
        case EditorState.EditingContent:


          if (this.state.selectedTargets.length > 0) {
            let target = this.state.selectedTargets[0];
            target.dom.contentEditable = "false";
            target.dom.classList.remove("editing-content");

            if (target.dom.textContent == ""&&!target.dom.innerHTML.includes("img")) {
              var sanitizedInput = sanitize((this.state.mode == EditorMode.Blogging&&target.layout.typename==wBComponentTypeNames.richText)?blogPlaceHolderText: editTextPlaceHolder);
              target.dom.innerHTML = sanitizedInput;
            }

            const editors = document.querySelectorAll(".ql-editor");

            for (let i = 0; i < editors.length; i++) {
              let ed = editors[i];
              ed.parentElement!.innerHTML = ed.innerHTML; //remove all editors
            }
            if (target.layout.content !== target.dom.innerHTML) {
              let content = target.dom.innerHTML;
              //let sanatizedContent =  content//.replace(/style="[^"]*"/g, ''); // remove all font coloring (may need to update with more cases as they are found)

                  let sanatizedContent = content
                    .replace('contenteditable="true"', "")
                    .replace("ql-editor", "");

                  target.layout.content = sanatizedContent;
                  if (target.layout.forceUpdate) target.layout.forceUpdate();

                  if (target.dom) {
                    // Sanitize the content before assigning it to innerHTML
                    let sanitizedContent = sanitize(sanatizedContent);
                    target.dom.innerHTML = sanitizedContent;
                }


            }
            this.saveUndoState();
          }

          break;
        case EditorState.Resizing:
          this.saveUndoState(); // save after a resize event
          break;
        case EditorState.MovingAbsolute:
          const roundVal = (key: string, node: LayoutNode) => {
            let getVal = getNodeStyleAttributeValue(
              node,
              this.state.screenSize,
              key,
              ""
            );
            let num = parseFloat(getVal);
            if (!isNaN(num)) {
              setNodeStyleAttributeValue(
                node,
                this.state.screenSize,
                key,
                Math.round(num) + "px"
              );
            }
          };

          if (this.resizeTarget?.layout) {
            roundVal(attributeTypes.left, this.resizeTarget.layout);
            roundVal(attributeTypes.top, this.resizeTarget.layout);
            roundVal(attributeTypes.width, this.resizeTarget.layout);
            roundVal(attributeTypes.height, this.resizeTarget.layout);
          }
          this.saveUndoState(); // save after a move event

          break;
        default:
          break;
      }

      this.setState({ editSate: newState });

      //after newState set
      switch (newState) {
        case EditorState.EditingContent:
          this.state.selectedTargets[0].dom.classList.add("editing-content");
          break;

        default:
          break;
      }
    }
  }

  deselectAll(togglePanel = true) {
    this.setState({ selectedTargets: [] });
    //this.checkDirty();
    if (togglePanel) this.autoToggleRightPanel(false);
  }

  selectParentOfCurrentSelected() {
    let target = this.latestSelection();

    if (
      target &&
      target.layout.parent &&
      target.layout.parent !== this.state.layout
    ) {
      // don't select the root

      let dom = document.getElementById(target.layout.parent.id);
      if (dom) {
        this.selectElement(dom, false);
      }
    }
  }

  moveComponentAdjacent(obj: LayoutNode, direction: number) {
    if (obj.parent) {
      let index = obj.parent.children.indexOf(obj);

      let min = 0;
      let max = obj.parent.children.length - 1;

      if (obj.typename === wBComponentTypeNames.section) {
        min = 1;
        max--;
      }

      let newIndex = index + direction;

      if (newIndex >= min && newIndex <= max) {
        let temp = obj.parent.children[newIndex];

        obj.parent.children[newIndex] = obj;
        obj.parent.children[index] = temp;
        temp.childIndex = index;
        obj.childIndex = newIndex;
        this.updateMasterLayout();

        if (obj.typename == wBComponentTypeNames.section) {
          setTimeout(() => {
            let dom = document.getElementById(obj.id);
            if (dom) {
              dom.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          });
        }
      }
    }
  }

  objectCanMoveInDirection(obj: LayoutNode, direction: number) {
    if (obj.parent) {
      let index = obj.parent.children.indexOf(obj);

      let min = 0;
      let max = obj.parent.children.length - 1;

      if (obj.typename === wBComponentTypeNames.section) {
        min = 1;
        max--;
      }

      return index + direction >= min && index + direction <= max;
    }
    return false;
  }

  selectElementByLayoutObj(obj: LayoutNode) {
    let dom = document.getElementById(obj.id);
    if (dom) {
      this.setState({ selectedTargets: [{ dom: dom, layout: obj }] });
    }
    //this.checkDirty();
  }

  selectElement(elem: HTMLElement | null | undefined, multiSelect = false) {
    //this.checkDirty();
    if (!elem || elem.id === this.state.layout.id) {
      //selecting the root element clears the selection
      if (multiSelect)
        // multiseclect simply ignore this selection
        return;
    } else {
      if(!elem.classList.contains("no-expand")){ // don't auto open when editing rich text
        this.autoToggleRightPanel(true);
      }
      this.onDeselectMenu();
    }

    if (this.componentDirty) {
      let found = false;
      for (let i = 0; i < this.state.selectedTargets.length; i++) {
        if (this.state.selectedTargets[i].dom === elem) {
          found = true;
          break;
        }
      }

      if (!found) {
        this.saveUndoState();
        this.componentDirty = false;
      }
    }

    if (!multiSelect) {
      if (elem) {
        let layoutObj = this.getLayoutNodeById(elem.id ?? "");
        if (layoutObj !== null) {
          this.setState({
            selectedTargets: [{ dom: elem as HTMLElement, layout: layoutObj }],
            styleMenuState: StyleBuilderState.SelectedComponent,
          });
        }
      }
    } else {
      let targets = this.state.selectedTargets;

      let layoutObj = this.getLayoutNodeById(elem?.id ?? "");

      if (layoutObj !== null) {
        targets.push({ dom: elem as HTMLElement, layout: layoutObj });

        this.setState({
          selectedTargets: targets,
          styleMenuState: StyleBuilderState.SelectedComponent,
        });
      }
    }
  }

  hoverElement(elem: HTMLElement | null) {
    if (this.hoveredDom !== elem) {
      this.hoveredDom = elem;
      if (this.updateHoverComponent) this.updateHoverComponent(elem);
    }
  }

  hoverById(id: string) {
    let dom = document.getElementById(id);
    if (dom) {
      this.hoverElement(dom);
    }
  }

  squaredDistanceToCenterRect(
    px: number,
    py: number,
    rx: number,
    ry: number,
    rwidth: number,
    rheight: number
  ) {
    let midX = rx + rwidth / 2;
    let midY = ry + rheight / 2;
    const deltaX = px - midX;
    const deltaY = py - midY;
    return deltaX * deltaX + deltaY * deltaY;
  }

  squaredDistanceToRectCenter(
    px: number,
    py: number,
    rx: number,
    ry: number,
    rwidth: number,
    rheight: number
  ) {
    let cx = rx + rwidth * 0.5;
    let cy = ry + rheight * 0.5;
    return (px - cx) * (px - cx) + (py - cy) * (py - cy);
  }

  clearActiveDropPoint() {
    if (this.activeDropPoint) {
      this.activeDropPoint.classList.remove("active");
      this.activeDropPoint = null;
    }
  }

  setActiveDropPoint(elem: HTMLElement) {
    if (this.activeDropPoint?.id !== elem.id) {
      if (this.activeDropPoint) {
        this.activeDropPoint.classList.remove("active");
      }
      this.activeDropPoint = elem;
      this.activeDropPoint.classList.add("active");
    }
  }

  activateClosestDropPoint(
    baseElement: HTMLElement | null,
    x: number,
    y: number,
    dropList: string[]
  ) {
    if (this.state.draggedLayoutNode === null) {
      // if no layout object ignore

      this.clearActiveDropPoint();
      return;
    }

    if (!this.isPointInsideCanvas(x, y)) {
      this.clearActiveDropPoint();
      return;
    }

    let allDropTargets = this.availableDropTargets;

    let closestDistance = 99999999999; //arbitrary large number
    let closest = -1;

    for (let i = 0; i < allDropTargets.length; i++) {
      let point = allDropTargets[i];

      //check the drop points referenced component name in its attribute to see if we can drop here
      let wbComponent = point.getAttribute("wbcomponent");

      if (wbComponent !== null && !dropList.includes(wbComponent)) continue;

      let rect = point.getBoundingClientRect();

      let distance = Math.sqrt(
        this.squaredDistanceToCenterRect(
          x,
          y,
          rect.left,
          rect.top,
          rect.width,
          rect.height
        )
      );

      //bias towards the current droppoint to avoid edge case flickering
      if (point === this.activeDropPoint) {
        distance -= 5;
      }

      if (distance < closestDistance) {
        closestDistance = distance;
        closest = i;
      }
    }

    if (closest >= 0) {
      this.setActiveDropPoint(allDropTargets[closest] as HTMLElement);
    } else {
      this.clearActiveDropPoint();
    }
  }

  revertMove(moveObj: LayoutNode) {
    if (moveObj.parent) {
      moveObj.parent.children?.splice(moveObj.childIndex, 0, moveObj);
    } else {
      this.deleteObjectById(moveObj.id);
    }
  }

  moveComponentByObj(
    moveObj: LayoutNode | null,
    newParent: LayoutNode,
    newChildIndex: number,
    applyToUndos: boolean = true
  ) {
    let layout = this.state.layout;

    if (moveObj === null || newParent === null) {
      if (moveObj)
        //invalid move attempt, revert the position of the move object
        this.revertMove(moveObj);

      return;
    }
    //start succsefull move

    if (!newParent.children) {
      newParent.children = [moveObj];
    } else {
      newParent.children.splice(newChildIndex, 0, moveObj);
    }

    if (!moveObj.parent)
      // unassigned objected, add to the lookup dictionary
      this.layoutNodeDictionary[moveObj.id] = moveObj;

    moveObj.parent = newParent;
    moveObj.childIndex = newChildIndex;

    this.setState({ layout: layout });
    if (applyToUndos) this.saveUndoState();
  }
  //recursively finds the LayoutObject from a root
  private getLayoutNodeRecursive(
    id: string,
    obj: LayoutNode,
    removeWhenFound: boolean = false
  ): LayoutNode | null {
    if (obj.id === id)
      // for the root
      return obj;

    let children = obj.children;

    if (children !== null) {
      for (let i = 0; i < children.length; i++) {
        let child = children[i];

        //assign parent and child data when iterating or returning an object.
        child.childIndex = i;
        child.parent = obj;

        if (child.id === id) {
          if (removeWhenFound && obj.children) {
            obj.children.splice(i, 1);
          }
          return child;
        }

        let result = this.getLayoutNodeRecursive(id, child, removeWhenFound);
        if (result !== null) return result;
      }
    }

    return null;
  }

  getLayoutNodeById(id: string): LayoutNode | null {
    return this.layoutNodeDictionary[id];
  }

  //returns the id of the hierarchy object that contains this drop point and the child index
  private GetMoveInfoFromActiveDropPoint(): {
    parent: LayoutNode | null;
    index: number;
  } {
    if (this.activeDropPoint === null) return { parent: null, index: -1 };

    let point = this.activeDropPoint;
    let hierarchyParent = ClosestWithClass(point,"hierarchy"); //find the parent hierarchy obj, this will be where we are dropping into;
    if (hierarchyParent === null) return { parent: null, index: -1 };

    let parent = point.parentElement;
    if (parent === null) {
      return { parent: null, index: -1 };
    }

    let index = 0;

    for (let i = 0; i < parent.children.length; i++) {
      if (parent.children[i].classList.contains("hierarchy")) index++;
      else if (parent.children[i] === point) {
        break;
      }
    }

    let returnParent = this.getLayoutNodeById(hierarchyParent?.id??"");

    return { parent: returnParent, index: index };
  }

  startDragFromId(id: string) {
    //use the recursive version here to make sure we update all layout parents and children and remove the correct obj
    let obj = this.getLayoutNodeById(id);

    if (obj) {


      const comp = GetWBComponentByTypename(obj.typename);


      if (comp == null || comp.isStatic) return;

      if (obj.parent) {
        let parent = obj.parent;

        for (let i = 0; i < parent.children?.length; i++) {
          parent.children[i].childIndex = i;

          if (parent.children[i].id === obj.id) {
            parent.children.splice(i, 1);
            i--;
          }
        }
      }

      this.startDrag(obj);
    }
  }

  startDrag(obj: LayoutNode) {
    if (!this.autoScrollIntervalId || this.autoScrollIntervalId < 0) {
      this.autoScrollIntervalId = setInterval(() => {
        this.tryAutoScroll();
      }, 1000 / 60);
    }

    const comp = GetWBComponentByTypename(obj.typename);
    this.previousSelection = null; //reset the previous selection when starting a drag so the user still needs to click twice to edit content

    if (comp == null || comp.isStatic) return;

    this.draggedDropList = comp.dropList;

    if(this.state.mode == EditorMode.Blogging){ // remove the ability to drop certain components when blogging, users shouldn't be able to add new columns or sections
      this.draggedDropList = this.draggedDropList.filter(x=>!nonDropWhenBloggingComponents.includes(x));
    }

    document.body.classList.add("dragging-global");
    this.activeDropPoint = null;
    this.setState({ draggedLayoutNode: obj });
    this.switchToEditorState(EditorState.Dragging);
  }

  endDrag() {
    if (this.autoScrollIntervalId >= 0) {
      clearInterval(this.autoScrollIntervalId);
      this.autoScrollIntervalId = -1;
    }
    this.previousSelection = null;
    if (this.state.editSate !== EditorState.Dragging) return;

    let targets = document.querySelectorAll(".drop-target.active");
    document.body.classList.remove("dragging-global");
    for (let i = 0; i < targets.length; i++) {
      targets[i].classList.remove("active");
    }

    let openToTemplateMenu = false;

    if (!this.activeDropPoint) {
      if (this.state.draggedLayoutNode) {
        this.revertMove(this.state.draggedLayoutNode);
      }
    } else {
      let moveInfo = this.GetMoveInfoFromActiveDropPoint();

      //kludge to fix issue with sections being off by one. Will revisit if time allows

      if (moveInfo.index >= 0 && this.state.draggedLayoutNode) {
        let moveID = this.state.draggedLayoutNode.id;

        if (moveID) {
          const parent = moveInfo.parent;

          if (!parent) {
            return;
          }

          let isNew = this.state.draggedLayoutNode.parent === null;

          let dNode = this.state.draggedLayoutNode;
          //special case for dragging an object inside of a page root
          if (
            parent.typename == wBComponentTypeNames.pageRoot &&
            dNode.typename != wBComponentTypeNames.section
          ) {
            if (dNode && dNode.typename != wBComponentTypeNames.section) {
              let sectionNode = CreateBlankLayoutNode(
                wBComponentTypeNames.section
              );
              this.moveComponentByObj(
                sectionNode,
                parent,
                moveInfo.index,
                false
              );

              if (dNode.typename == wBComponentTypeNames.column) {
                //move the column into the section
                this.moveComponentByObj(dNode, sectionNode, 0, false);

                GetWBComponentByTypename(
                  wBComponentTypeNames.column
                ).onFirstTimeCreation(sectionNode, dNode, this);
              } else {
                // create a new column to hold this new component
                let colNode = CreateBlankLayoutNode(
                  wBComponentTypeNames.column
                );
                this.moveComponentByObj(colNode, sectionNode, 0, false);
                GetWBComponentByTypename(
                  wBComponentTypeNames.column
                ).onFirstTimeCreation(sectionNode, colNode, this);
                this.moveComponentByObj(dNode, colNode, 0, true);
              }

              this.setState({ draggedLayoutNode: dNode });
              if (this.config.ignoreFirstCreationWhenNested) isNew = false; // remove to allow  template creations
            }
          }
          //adding to a section when not a column
          else if (
            (parent.typename == wBComponentTypeNames.section ||
              parent.typename == wBComponentTypeNames.footer) &&
            dNode.typename != wBComponentTypeNames.column
          ) {
            if (dNode) {
              // create a new column to hold this new component
              let colNode = CreateBlankLayoutNode(wBComponentTypeNames.column);
              this.moveComponentByObj(colNode, parent, moveInfo.index, false);
              GetWBComponentByTypename(
                wBComponentTypeNames.column
              ).onFirstTimeCreation(parent, colNode, this);
              this.moveComponentByObj(dNode, colNode, 0, true);

              this.setState({ draggedLayoutNode: dNode });
              if (this.config.ignoreFirstCreationWhenNested) isNew = false; // remove to allow  template creations
            }
          } else {
            this.moveComponentByObj(
              this.state.draggedLayoutNode,
              parent,
              moveInfo.index
            );
          }

          if (dNode && isNew) {
            const component = GetWBComponentByTypename(dNode.typename);

            component.onFirstTimeCreation(dNode.parent ?? parent, dNode, this);

            dNode.content = "";

            if (component.showTemplateOptions) {
              this.openTemplateMenu(dNode);
              openToTemplateMenu = true;
            }
          }
        }
      }
    }

    if (
      this.state.draggedLayoutNode &&
      this.state.draggedLayoutNode.parent != null
    ) {
      let id = this.state?.draggedLayoutNode?.id;
      let content = this.state?.draggedLayoutNode?.content;
      if (id)
        setTimeout(() => {
          this.selectElement(document.getElementById(id));

          this.handleMouseUp(new MouseEvent("mouseup", { button: 0 }));

          if (content == "") {
            let dom = document.getElementById(id);
            if (dom) {
              this.hoveredDom = dom;
              this.tryEditContentOfHoveredElement(true);
            }
          }
        }, 0); //by setting a timeout this function will always happen after the render
    }

    this.activeDropPoint = null;
    this.setState({ draggedLayoutNode: null });
    if (!openToTemplateMenu) this.switchToEditorState(EditorState.Normal);
  }

  openTemplateMenu(node: LayoutNode) {
    this.templateNode = node;
    this.switchToEditorState(EditorState.TemplateMenu);
  }

  //creates a flat dictionary with all layout objectes for simpiler reference
  fillLayoutNodeDictionaryRecursive(
    layoutDict: { [key: string]: LayoutNode },
    obj: LayoutNode,
    toggleRender = true
  ) {
    if (!obj) {
      return;
    }

    obj.inView = true;
    layoutDict[obj.id] = obj;

    if (obj.children) {
      for (let i = 0; i < obj.children.length; i++) {
        obj.children[i].parent = obj;
        obj.children[i].childIndex = i;

        this.fillLayoutNodeDictionaryRecursive(layoutDict, obj.children[i]);
      }
    }
  }

  deleteObjectById(id: string, forceDelete = false) {

    let obj = this.getLayoutNodeById(id);

    if (!obj) {
      return;
    }
    let comp = GetWBComponentByTypename(obj.typename);
    if (comp == null || (comp.isStatic&&!forceDelete)) return;

    this.getLayoutNodeRecursive(id, this.state.layout, true);

    delete this.layoutNodeDictionary[id];
  }

  openToVersionHistory() {
    this.switchToEditorState(EditorState.Locked);
    let dom = document.getElementById("version-history-popup");
    if (dom) {
      ReactDOM.unmountComponentAtNode(dom);

      ReactDOM.render(
        <VersionHistoryMenu
          siteData={this.props.siteData}
          onDismiss={() => {
            ReactDOM.unmountComponentAtNode(dom as HTMLElement);
            this.switchToEditorState(EditorState.Normal);
            let styleDom = document.getElementById("site-main-styling");//restore original styling
            if (styleDom) {
              styleDom.innerHTML = generateGlobalStyleFromSiteData(this.props.siteData.siteStyling);
            }

          }}
        />,
        dom
      );
    }
  }

  initBlogPageLayout() {

    let root = this.state.layout;

    setNodeComponentAttributeValue(root,"pageType","blog");
    if(root.children.length != 2){

      return;
    }

    let titleSection = CreateBlankLayoutNode(wBComponentTypeNames.blogHeading);
    let section = CreateBlankLayoutNode(wBComponentTypeNames.section);
    let column = CreateBlankLayoutNode(wBComponentTypeNames.column);
    column.screenSizeStyleAttributes[0] = {justifyContent:"flex-start"};
    let rText = CreateBlankLayoutNode(wBComponentTypeNames.richText);
    rText.content = blogPlaceHolderText;


    this.moveComponentByObj(titleSection, root, 1);
    this.moveComponentByObj(section, root,2);

    this.moveComponentByObj(column, section, 0);
    this.moveComponentByObj(rText, column, 1);




  }

  activateAllForms() {

    ProcessNodes(this.state.layout, (node) => {
      if(node.typename === wBComponentTypeNames.businessForm){
          if(node.data){
            node.data.isActivate = true;
            node.forceUpdate();
          }
      }
    });
   if(this.state.editSate == EditorState.Preview){
      this.switchToEditorState(EditorState.Normal);
    }


  }
}
